import { mergeProps } from 'solid-js';

// 不同颜色的ICON，说明：纯色可复用放至ICONS文件夹下
export const OpenAccountBg = ({ style }) => (
  <svg
    width="414"
    height="560"
    viewBox="0 0 414 560"
    stroke="none"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <mask id="mask0_254_1362" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="414" height="520">
      <path
        d="M0 0H414V464.494C327.555 476.233 282.79 491.554 207 520C128.716 488.906 83.6605 473.35 0 464.494V0Z"
        fill="#FF5F43"
      />
    </mask>
    <g mask="url(#mask0_254_1362)">
      <path
        d="M0 0H414V464.494C327.555 476.233 282.79 491.554 207 520C128.716 488.906 83.6605 473.35 0 464.494V0Z"
        fill="url(#paint0_linear_254_1362)"
      />
      <g style="mix-blend-mode:plus-lighter" opacity="0.6">
        <g opacity="0.5" filter="url(#filter0_f_254_1362)">
          <g opacity="0.8" filter="url(#filter1_f_254_1362)">
            <path
              d="M425.731 -69.5273L429.425 -63.4022L283.117 75.827L182.413 168.822L279.422 69.7019L425.731 -69.5273Z"
              fill="url(#paint1_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter2_f_254_1362)">
            <path
              d="M416.447 -96.802L420.141 -90.6769L273.832 48.5523L173.129 141.547L270.138 42.4272L416.447 -96.802Z"
              fill="url(#paint2_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter3_f_254_1362)" style="mix-blend-mode:soft-light">
            <path
              d="M460.13 -80.2498L463.824 -74.1246L317.516 65.1046L216.812 158.099L313.821 58.9794L460.13 -80.2498Z"
              fill="url(#paint3_linear_254_1362)"
            />
          </g>
          <g opacity="0.2" filter="url(#filter4_f_254_1362)" style="mix-blend-mode:plus-lighter">
            <path
              d="M408.995 -69.7332L412.689 -63.608L266.381 75.6212L165.677 168.616L262.687 69.496L408.995 -69.7332Z"
              fill="url(#paint4_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter5_f_254_1362)">
            <path
              d="M419.63 -65.1145L422.835 -58.4301L244.707 116.437L122.481 233.532L241.501 109.753L419.63 -65.1145Z"
              fill="url(#paint5_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter6_f_254_1362)">
            <path
              d="M413.167 -95.594L416.372 -88.9096L238.243 85.9576L116.018 203.053L235.038 79.2733L413.167 -95.594Z"
              fill="url(#paint6_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter7_f_254_1362)" style="mix-blend-mode:soft-light">
            <path
              d="M458.56 -80.885L461.765 -74.2006L283.636 100.667L161.411 217.762L280.431 93.9822L458.56 -80.885Z"
              fill="url(#paint7_linear_254_1362)"
            />
          </g>
          <g opacity="0.2" filter="url(#filter8_f_254_1362)" style="mix-blend-mode:plus-lighter">
            <path
              d="M401.417 -63.6865L404.622 -57.0022L226.494 117.865L104.268 234.96L223.288 111.181L401.417 -63.6865Z"
              fill="url(#paint8_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter9_f_254_1362)">
            <path
              d="M428.286 -61.6011L431.495 -54.9595L256.05 113.677L135.65 226.542L252.84 107.036L428.286 -61.6011Z"
              fill="url(#paint9_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter10_f_254_1362)">
            <path
              d="M421.724 -91.7249L424.933 -85.0833L249.488 83.5533L129.088 196.419L246.278 76.9118L421.724 -91.7249Z"
              fill="url(#paint10_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter11_f_254_1362)" style="mix-blend-mode:soft-light">
            <path
              d="M466.749 -76.3628L469.959 -69.7213L294.513 98.9154L174.114 211.781L291.304 92.2739L466.749 -76.3628Z"
              fill="url(#paint11_linear_254_1362)"
            />
          </g>
          <g opacity="0.2" filter="url(#filter12_f_254_1362)" style="mix-blend-mode:plus-lighter">
            <path
              d="M410.259 -60.5505L413.469 -53.909L238.023 114.728L117.624 227.593L234.814 108.086L410.259 -60.5505Z"
              fill="url(#paint12_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter13_f_254_1362)">
            <path
              d="M391.057 -89.616L399.56 -81.8573L242.951 120.716L133.82 256.359L234.449 112.957L391.057 -89.616Z"
              fill="url(#paint13_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter14_f_254_1362)">
            <path
              d="M357.93 -119.496L366.433 -111.738L209.824 90.8356L100.693 226.479L201.322 83.077L357.93 -119.496Z"
              fill="url(#paint14_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter15_f_254_1362)" style="mix-blend-mode:soft-light">
            <path
              d="M438.26 -107.854L446.763 -100.096L290.154 102.478L181.023 238.121L281.651 94.719L438.26 -107.854Z"
              fill="url(#paint15_linear_254_1362)"
            />
          </g>
          <g opacity="0.2" filter="url(#filter16_f_254_1362)" style="mix-blend-mode:plus-lighter">
            <path
              d="M401.406 -93.9246L409.909 -86.1659L253.301 116.407L144.169 252.05L244.798 108.649L401.406 -93.9246Z"
              fill="url(#paint16_linear_254_1362)"
            />
          </g>
          <g opacity="0.2" filter="url(#filter17_f_254_1362)" style="mix-blend-mode:plus-lighter">
            <path
              d="M324.745 -26.3464L333.248 -18.5878L176.639 183.986L67.5079 319.629L168.137 176.227L324.745 -26.3464Z"
              fill="url(#paint17_linear_254_1362)"
            />
          </g>
        </g>
        <g opacity="0.5">
          <g opacity="0.8" filter="url(#filter18_f_254_1362)">
            <path
              d="M371.471 -67.8804L378.397 -62.1255L274.092 61.4207L201.036 143.846L267.165 55.6658L371.471 -67.8804Z"
              fill="url(#paint18_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter19_f_254_1362)">
            <path
              d="M348.772 -93.2805L355.699 -87.5256L251.393 36.0206L178.337 118.446L244.467 30.2657L348.772 -93.2805Z"
              fill="url(#paint19_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter20_f_254_1362)" style="mix-blend-mode:soft-light">
            <path
              d="M405.796 -76.665L412.723 -70.9101L308.417 52.636L235.361 135.062L301.491 46.8812L405.796 -76.665Z"
              fill="url(#paint20_linear_254_1362)"
            />
          </g>
          <g opacity="0.2" filter="url(#filter21_f_254_1362)" style="mix-blend-mode:plus-lighter">
            <path
              d="M352.356 -68.5977L359.282 -62.8428L254.977 60.7034L181.921 143.129L248.051 54.9485L352.356 -68.5977Z"
              fill="url(#paint21_linear_254_1362)"
            />
          </g>
        </g>
        <g opacity="0.5">
          <g opacity="0.8" filter="url(#filter22_f_254_1362)">
            <path
              d="M375.551 -68.5022L381.772 -63.1359L286.652 53.5763L220.058 131.463L280.432 48.2099L375.551 -68.5022Z"
              fill="url(#paint22_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter23_f_254_1362)">
            <path
              d="M355.216 -92.2314L361.437 -86.8651L266.317 29.847L199.723 107.734L260.097 24.4807L355.216 -92.2314Z"
              fill="url(#paint23_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter24_f_254_1362)" style="mix-blend-mode:soft-light">
            <path
              d="M406.632 -76.9646L412.852 -71.5983L317.733 45.1139L251.139 123.001L311.512 39.7475L406.632 -76.9646Z"
              fill="url(#paint24_linear_254_1362)"
            />
          </g>
          <g opacity="0.2" filter="url(#filter25_f_254_1362)" style="mix-blend-mode:plus-lighter">
            <path
              d="M358.282 -69.0618L364.503 -63.6954L269.383 53.0167L202.789 130.903L263.163 47.6504L358.282 -69.0618Z"
              fill="url(#paint25_linear_254_1362)"
            />
          </g>
        </g>
        <g opacity="0.5">
          <g opacity="0.8" filter="url(#filter26_f_254_1362)">
            <path
              d="M363.963 -68.3433L372.255 -61.8954L250.653 73.12L165.419 163.151L242.362 66.6721L363.963 -68.3433Z"
              fill="url(#paint26_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter27_f_254_1362)">
            <path
              d="M350.911 -78.1511L359.202 -71.7033L237.601 63.3121L152.367 153.343L229.31 56.8643L350.911 -78.1511Z"
              fill="url(#paint27_linear_254_1362)"
            />
          </g>
          <g opacity="0.8" filter="url(#filter28_f_254_1362)">
            <path
              d="M331.686 -93.2119L339.977 -86.7641L218.375 48.2513L133.141 138.282L210.084 41.8035L331.686 -93.2119Z"
              fill="url(#paint28_linear_254_1362)"
            />
          </g>
          <g opacity="0.83" filter="url(#filter29_f_254_1362)" style="mix-blend-mode:soft-light">
            <path
              d="M404.473 -77.5828L412.764 -71.1349L291.163 63.8805L205.929 153.911L282.872 57.4326L404.473 -77.5828Z"
              fill="url(#paint29_linear_254_1362)"
            />
          </g>
          <g opacity="0.24" filter="url(#filter30_f_254_1362)" style="mix-blend-mode:plus-lighter">
            <path
              d="M372.817 -70.5964L381.108 -64.1486L259.507 70.8668L174.272 160.897L251.215 64.4189L372.817 -70.5964Z"
              fill="url(#paint30_linear_254_1362)"
            />
          </g>
          <g filter="url(#filter31_f_254_1362)" style="mix-blend-mode:plus-lighter">
            <path
              d="M405.554 -41.3433L413.845 -34.8954L292.243 100.12L207.009 190.151L283.952 93.6721L405.554 -41.3433Z"
              fill="url(#paint31_linear_254_1362)"
            />
          </g>
        </g>
        <g opacity="0.8" filter="url(#filter32_f_254_1362)">
          <path
            d="M459.984 -16.9648L465.254 -12.0064L381.627 98.9014L323.138 172.956L376.357 93.943L459.984 -16.9648Z"
            fill="url(#paint32_linear_254_1362)"
          />
        </g>
        <g opacity="0.8" filter="url(#filter33_f_254_1362)">
          <path
            d="M442.852 -38.9846L448.121 -34.0262L364.494 76.8816L306.005 150.936L359.225 71.9232L442.852 -38.9846Z"
            fill="url(#paint33_linear_254_1362)"
          />
        </g>
        <g opacity="0.8" filter="url(#filter34_f_254_1362)" style="mix-blend-mode:soft-light">
          <path
            d="M486.855 -25.3269L492.125 -20.3685L408.498 90.5393L350.008 164.594L403.228 85.5809L486.855 -25.3269Z"
            fill="url(#paint34_linear_254_1362)"
          />
        </g>
        <g opacity="0.2" filter="url(#filter35_f_254_1362)" style="mix-blend-mode:plus-lighter">
          <path
            d="M439 -33L450.405 -12.3016L366.778 98.6062L308.288 172.661L361.508 93.6478L439 -33Z"
            fill="url(#paint35_linear_254_1362)"
          />
        </g>
      </g>
    </g>
    <g filter="url(#filter36_d_254_1362)">
      <path
        d="M414 455.052C342.682 459.51 285.626 480.223 214.14 517.764C292.079 493.504 344.598 475 414 475V455.052Z"
        fill="url(#paint36_linear_254_1362)"
      />
    </g>
    <g filter="url(#filter37_d_254_1362)">
      <path
        d="M0 454.288C71.3176 458.745 128.374 479.459 199.86 517C121.921 492.74 69.4016 474.236 0 474.236V454.288Z"
        fill="url(#paint37_linear_254_1362)"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M264.66 422.403L261.756 419.387L257.491 419.639L206.299 418.525C206.299 418.525 193.751 416.545 190.618 429.011L179.49 502.385C179.49 502.385 176.034 516.26 189.569 516.944L243.33 520.305C243.33 520.305 256.249 518.249 257.827 505.886C261.062 484.317 261.52 484.47 267.905 436.446C267.899 436.446 269.682 427.193 264.66 422.403Z"
      fill="#F8A247"
    />
    <path
      d="M200.309 415.643C200.919 415.642 201.42 415.672 201.767 415.701C201.939 415.716 202.073 415.73 202.163 415.741C202.208 415.747 202.242 415.752 202.264 415.755C202.275 415.756 202.283 415.757 202.288 415.758C202.29 415.758 202.292 415.759 202.293 415.759H202.294L202.326 415.764L202.358 415.765L253.868 416.889C257.016 417.123 259.198 418.013 260.714 419.182C262.231 420.351 263.114 421.825 263.618 423.285C264.124 424.749 264.246 426.192 264.24 427.275C264.237 427.815 264.202 428.262 264.168 428.572C264.151 428.727 264.135 428.847 264.123 428.928C264.117 428.968 264.112 428.998 264.108 429.017C264.107 429.027 264.105 429.034 264.104 429.038C264.104 429.04 264.104 429.042 264.104 429.043L264.101 429.061L264.099 429.08C262.985 439.027 260.313 457.391 257.917 473.277C256.719 481.218 255.591 488.537 254.763 493.871C254.348 496.538 254.009 498.708 253.773 500.212C253.656 500.964 253.564 501.549 253.501 501.946C253.47 502.145 253.446 502.296 253.43 502.398C253.422 502.449 253.415 502.488 253.411 502.514C253.409 502.526 253.407 502.536 253.406 502.543C253.406 502.546 253.406 502.548 253.405 502.55V502.552C253.408 502.552 253.442 502.558 253.898 502.63L253.405 502.553L253.404 502.559L253.403 502.567C252.64 508.561 249.398 511.613 246.354 513.185C244.824 513.976 243.338 514.395 242.233 514.615C241.682 514.725 241.227 514.786 240.913 514.818C240.756 514.835 240.634 514.844 240.553 514.849C240.512 514.852 240.482 514.853 240.462 514.854C240.461 514.854 240.459 514.854 240.458 514.854L186.727 511.204H186.724C183.59 511.009 181.458 510.027 180.005 508.703C178.546 507.374 177.728 505.662 177.292 503.944C176.855 502.224 176.807 500.519 176.869 499.236C176.9 498.597 176.958 498.067 177.009 497.698C177.034 497.514 177.058 497.37 177.074 497.273C177.083 497.225 177.089 497.189 177.094 497.165C177.096 497.153 177.098 497.144 177.099 497.139C177.099 497.136 177.099 497.134 177.1 497.133V497.132L177.101 497.133L177.104 497.117L177.105 497.101L187.184 425.436C188.515 419.637 192.263 417.236 195.7 416.263C197.431 415.772 199.085 415.646 200.309 415.643Z"
      fill="#FFE5BB"
      stroke="url(#paint38_linear_254_1362)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M201.386 424.698L249.567 426.012C249.567 426.012 256.1 425.846 255.421 432.613L252.551 453.685C252.551 453.685 252.147 460.71 244.084 460.587L198.572 458.698C198.572 458.698 191.047 458.575 191.877 451.81L194.548 429.821C194.548 429.821 194.495 424.576 201.386 424.698Z"
      fill="#FF6A01"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M194.53 466.784L244.929 469.354C246.785 469.354 248.289 470.858 248.289 472.714C248.289 474.57 246.785 476.074 244.929 476.074L194.53 473.504C192.674 473.504 191.17 472 191.17 470.144C191.17 468.288 192.674 466.784 194.53 466.784Z"
      fill="#FFD694"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M192.903 480.223L244.22 483.108C245.664 483.108 247.499 484.613 247.499 486.469C247.499 488.325 245.673 489.827 244.22 489.827L192.903 486.943C190.434 486.943 189.25 485.439 189.25 483.585C189.25 481.731 190.434 480.223 192.903 480.223Z"
      fill="#FFD694"
    />
    <path
      d="M202.006 451.544C201.008 451.544 200.106 450.948 199.715 450.031C199.323 449.113 199.517 448.051 200.208 447.33C200.243 447.296 203.649 443.744 207.966 439.652C209.842 437.826 214.694 435.487 219.771 439.612L219.859 439.682L225.46 445.137C226.128 445.645 226.895 446.006 227.711 446.193C229.343 446.55 230.866 446.027 232.391 444.593L232.433 444.555L243.588 434.479C244.247 433.873 245.18 433.667 246.033 433.94C246.885 434.212 247.525 434.921 247.711 435.797C247.896 436.672 247.597 437.58 246.926 438.175L235.79 448.224C232.24 451.564 228.703 451.567 226.357 450.981C224.813 450.593 223.375 449.864 222.148 448.849L222.059 448.766L216.55 443.409C215.332 442.445 214.178 442.117 213.027 442.413C212.438 442.569 211.892 442.851 211.425 443.243L211.397 443.273L211.407 443.261C207.175 447.274 203.837 450.75 203.804 450.785C203.332 451.272 202.683 451.546 202.006 451.544Z"
      fill="#FFE2B3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M196.072 489L203.294 500.942L215.707 504.084L226.647 519.167L243.175 520.086L222.784 528.598L166.53 498.144L196.072 489Z"
      fill="#F7C472"
      fill-opacity="0.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M191.93 520.82C191.014 524.805 182.421 527.717 172.04 527.717C161.659 527.717 152.284 524.939 152.191 520.955L152.138 520.608V514.923H156.68C160.332 513.189 165.852 512.081 172.033 512.081C178.214 512.081 183.74 513.184 187.393 514.923H191.943V520.611L191.93 520.82Z"
      fill="#FFBF59"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M172.04 508.225C183.032 508.225 191.943 511.223 191.943 514.925C191.943 518.627 183.032 521.627 172.04 521.627C161.048 521.627 152.138 518.627 152.138 514.925C152.138 511.223 161.048 508.225 172.04 508.225Z"
      fill="#FFD964"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M172.039 510.37C179.89 510.37 186.257 511.99 186.257 513.989C186.257 515.988 179.89 517.608 172.039 517.608C164.188 517.608 157.822 515.986 157.822 513.989C157.822 511.992 164.188 510.37 172.039 510.37Z"
      fill="#FFE6A4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M191.93 513.199C191.014 517.183 182.421 520.093 172.04 520.093C161.659 520.093 152.284 517.316 152.191 513.331L152.138 512.984V507.298H156.68C160.332 505.562 165.852 504.454 172.033 504.454C178.214 504.454 183.74 505.562 187.393 507.298H191.943V512.984L191.93 513.199Z"
      fill="#FFBF59"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M172.04 500.598C183.032 500.598 191.943 503.596 191.943 507.298C191.943 511 183.032 514 172.04 514C161.048 514 152.138 511 152.138 507.298C152.138 503.596 161.048 500.598 172.04 500.598Z"
      fill="#FFD964"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M172.039 502.743C179.89 502.743 186.257 504.363 186.257 506.362C186.257 508.361 179.89 509.981 172.039 509.981C164.188 509.981 157.822 508.359 157.822 506.362C157.822 504.365 164.188 502.743 172.039 502.743Z"
      fill="#FFE6A4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M191.93 505.437C191.014 509.422 182.421 512.334 172.04 512.334C161.659 512.334 152.284 509.556 152.191 505.572L152.138 505.223V499.537H156.68C160.332 497.802 165.852 496.693 172.033 496.693C178.214 496.693 183.74 497.802 187.393 499.537H191.943V505.223L191.93 505.437Z"
      fill="#FFBF59"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M172.04 492.837C183.032 492.837 191.943 495.837 191.943 499.539C191.943 503.241 183.032 506.241 172.04 506.241C161.048 506.241 152.138 503.239 152.138 499.539C152.138 495.838 161.048 492.837 172.04 492.837Z"
      fill="#FFD964"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M172.039 494.983C179.89 494.983 186.257 496.604 186.257 498.602C186.257 500.601 179.89 502.227 172.039 502.227C164.188 502.227 157.822 500.606 157.822 498.609C157.822 496.612 164.188 494.983 172.039 494.983Z"
      fill="#FFE6A4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M191.93 497.811C191.014 501.795 182.421 504.707 172.04 504.707C161.659 504.707 152.284 501.929 152.191 497.945L152.138 497.598V491.91H156.68C160.332 490.175 165.852 489.068 172.033 489.068C178.214 489.068 183.74 490.175 187.393 491.91H191.943V497.598L191.93 497.811Z"
      fill="#FFBF59"
    />
    <path
      d="M172.04 485.71C177.497 485.71 182.416 486.455 185.954 487.646C187.726 488.243 189.123 488.942 190.067 489.694C191.017 490.45 191.443 491.203 191.443 491.912C191.443 492.621 191.017 493.374 190.067 494.13C189.123 494.882 187.725 495.581 185.954 496.178C182.416 497.369 177.497 498.114 172.04 498.114C166.583 498.114 161.664 497.368 158.126 496.177C156.355 495.58 154.957 494.881 154.013 494.129C153.063 493.373 152.638 492.62 152.638 491.912C152.638 491.204 153.063 490.451 154.013 489.695C154.957 488.943 156.355 488.244 158.126 487.647C161.664 486.456 166.583 485.71 172.04 485.71Z"
      fill="#FFD964"
      stroke="url(#paint39_linear_254_1362)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M172.039 487.357C179.89 487.357 186.257 488.977 186.257 490.976C186.257 492.975 179.89 494.59 172.039 494.59C164.188 494.59 157.822 492.97 157.822 490.972C157.822 488.975 164.188 487.357 172.039 487.357Z"
      fill="#FFE6A4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M223.371 526.176C222.457 530.16 213.864 533.072 203.483 533.072C193.102 533.072 183.727 530.295 183.634 526.31L183.574 525.967V520.276H188.125C191.777 518.541 197.297 517.434 203.478 517.434C209.659 517.434 215.179 518.541 218.829 520.276H223.381V525.967L223.371 526.176Z"
      fill="#FFBF59"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M203.483 513.575C214.473 513.575 223.386 516.575 223.386 520.277C223.386 523.98 214.473 526.98 203.483 526.98C192.493 526.98 183.574 523.975 183.574 520.277C183.574 516.58 192.491 513.575 203.483 513.575Z"
      fill="#FFD964"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M203.483 515.722C211.334 515.722 217.699 517.342 217.699 519.341C217.699 521.34 211.334 522.959 203.483 522.959C195.632 522.959 189.265 521.338 189.265 519.341C189.265 517.344 195.63 515.722 203.483 515.722Z"
      fill="#FFE6A4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M223.371 518.549C222.457 522.534 213.864 525.446 203.483 525.446C193.102 525.446 183.727 522.668 183.634 518.684L183.574 518.33V512.649H188.125C191.777 510.914 197.297 509.807 203.478 509.807C209.659 509.807 215.179 510.914 218.829 512.649H223.381V518.33L223.371 518.549Z"
      fill="#FFBF59"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M203.483 505.95C214.473 505.95 223.386 508.949 223.386 512.651C223.386 516.353 214.473 519.353 203.483 519.353C192.493 519.353 183.574 516.351 183.574 512.651C183.574 508.95 192.491 505.95 203.483 505.95Z"
      fill="#FFD964"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M203.483 508.095C211.334 508.095 217.699 509.716 217.699 511.714C217.699 513.713 211.334 515.332 203.483 515.332C195.632 515.332 189.265 513.712 189.265 511.714C189.265 509.717 195.63 508.095 203.483 508.095Z"
      fill="#FFE6A4"
    />
    <defs>
      <filter
        id="filter0_f_254_1362"
        x="6.62174"
        y="-180.382"
        width="524.223"
        height="560.897"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="30.443" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter1_f_254_1362"
        x="129.983"
        y="-121.957"
        width="351.872"
        height="343.209"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter2_f_254_1362"
        x="120.699"
        y="-149.232"
        width="351.872"
        height="343.209"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter3_f_254_1362"
        x="164.382"
        y="-132.68"
        width="351.872"
        height="343.209"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter4_f_254_1362"
        x="135.85"
        y="-99.5605"
        width="306.667"
        height="298.004"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="14.9137" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter5_f_254_1362"
        x="70.0516"
        y="-117.544"
        width="405.214"
        height="403.506"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter6_f_254_1362"
        x="63.5882"
        y="-148.024"
        width="405.214"
        height="403.506"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter7_f_254_1362"
        x="108.981"
        y="-133.315"
        width="405.214"
        height="403.506"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter8_f_254_1362"
        x="74.4412"
        y="-93.5139"
        width="360.009"
        height="358.301"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="14.9137" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter9_f_254_1362"
        x="83.2206"
        y="-114.031"
        width="400.704"
        height="393.003"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter10_f_254_1362"
        x="76.6586"
        y="-144.155"
        width="400.704"
        height="393.003"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter11_f_254_1362"
        x="121.684"
        y="-128.793"
        width="400.704"
        height="393.003"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter12_f_254_1362"
        x="87.7966"
        y="-90.3779"
        width="355.5"
        height="347.798"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="14.9137" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter13_f_254_1362"
        x="81.39"
        y="-142.046"
        width="370.6"
        height="450.834"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter14_f_254_1362"
        x="48.2631"
        y="-171.926"
        width="370.6"
        height="450.834"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter15_f_254_1362"
        x="128.593"
        y="-160.284"
        width="370.6"
        height="450.834"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter16_f_254_1362"
        x="114.342"
        y="-123.752"
        width="325.395"
        height="405.63"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="14.9137" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter17_f_254_1362"
        x="37.6804"
        y="-56.1738"
        width="325.395"
        height="405.63"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="14.9137" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter18_f_254_1362"
        x="148.606"
        y="-120.31"
        width="282.221"
        height="316.586"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter19_f_254_1362"
        x="125.908"
        y="-145.71"
        width="282.221"
        height="316.586"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter20_f_254_1362"
        x="182.932"
        y="-129.095"
        width="282.221"
        height="316.586"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter21_f_254_1362"
        x="152.094"
        y="-98.4251"
        width="237.016"
        height="271.381"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="14.9137" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter22_f_254_1362"
        x="167.628"
        y="-120.932"
        width="266.573"
        height="304.825"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter23_f_254_1362"
        x="147.293"
        y="-144.661"
        width="266.573"
        height="304.825"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter24_f_254_1362"
        x="198.709"
        y="-129.394"
        width="266.573"
        height="304.825"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter25_f_254_1362"
        x="172.962"
        y="-98.8892"
        width="221.368"
        height="259.62"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="14.9137" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter26_f_254_1362"
        x="112.989"
        y="-120.773"
        width="311.695"
        height="336.354"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter27_f_254_1362"
        x="99.9369"
        y="-130.581"
        width="311.695"
        height="336.354"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter28_f_254_1362"
        x="80.7113"
        y="-145.642"
        width="311.695"
        height="336.354"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter29_f_254_1362"
        x="192.429"
        y="-91.0828"
        width="233.835"
        height="258.494"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="6.75" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter30_f_254_1362"
        x="164.272"
        y="-80.5964"
        width="226.835"
        height="251.494"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter31_f_254_1362"
        x="179.309"
        y="-69.0433"
        width="262.235"
        height="286.894"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="13.85" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter32_f_254_1362"
        x="270.708"
        y="-69.3947"
        width="246.976"
        height="294.781"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter33_f_254_1362"
        x="253.575"
        y="-91.4144"
        width="246.976"
        height="294.781"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter34_f_254_1362"
        x="297.578"
        y="-77.7567"
        width="246.976"
        height="294.781"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="26.2149" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter35_f_254_1362"
        x="287.588"
        y="-53.7"
        width="183.517"
        height="247.061"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="10.35" result="effect1_foregroundBlur_254_1362" />
      </filter>
      <filter
        id="filter36_d_254_1362"
        x="190.14"
        y="450.052"
        width="223.86"
        height="86.7119"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-12" dy="7" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.824176 0 0 0 0 0.692308 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_254_1362" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_254_1362" result="shape" />
      </filter>
      <filter
        id="filter37_d_254_1362"
        x="0"
        y="449.288"
        width="223.86"
        height="86.7119"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="12" dy="7" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.824176 0 0 0 0 0.692308 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_254_1362" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_254_1362" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_254_1362"
        x1="184"
        y1="517.079"
        x2="184"
        y2="-2.97757e-06"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF5F43" />
        <stop offset="0.403846" stop-color="#FF261F" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_254_1362"
        x1="427.578"
        y1="-66.4648"
        x2="258.72"
        y2="35.3759"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_254_1362"
        x1="418.294"
        y1="-93.7394"
        x2="249.436"
        y2="8.10127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_254_1362"
        x1="461.977"
        y1="-77.1872"
        x2="293.119"
        y2="24.6535"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_254_1362"
        x1="410.842"
        y1="-66.6706"
        x2="241.984"
        y2="35.1701"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_254_1362"
        x1="421.233"
        y1="-61.7723"
        x2="208.23"
        y2="40.3702"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_254_1362"
        x1="414.769"
        y1="-92.2518"
        x2="201.766"
        y2="9.89072"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_254_1362"
        x1="460.162"
        y1="-77.5428"
        x2="247.159"
        y2="24.5997"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_254_1362"
        x1="403.02"
        y1="-60.3443"
        x2="190.017"
        y2="41.7982"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_254_1362"
        x1="429.89"
        y1="-58.2803"
        x2="221.595"
        y2="42.3795"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_254_1362"
        x1="423.328"
        y1="-88.4041"
        x2="215.033"
        y2="12.2558"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_254_1362"
        x1="468.354"
        y1="-73.042"
        x2="260.058"
        y2="27.6178"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_254_1362"
        x1="411.864"
        y1="-57.2298"
        x2="203.569"
        y2="43.4301"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_254_1362"
        x1="395.309"
        y1="-85.7366"
        x2="223.293"
        y2="102.778"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.557292" stop-color="#B8F76E" />
        <stop offset="1" stop-color="#B8F76E" stop-opacity="0.3" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_254_1362"
        x1="362.182"
        y1="-115.617"
        x2="190.166"
        y2="72.8972"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_254_1362"
        x1="442.511"
        y1="-103.975"
        x2="270.495"
        y2="84.5393"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.557292" stop-color="#B8F76E" />
        <stop offset="1" stop-color="#B8F76E" stop-opacity="0.3" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_254_1362"
        x1="405.658"
        y1="-90.0452"
        x2="233.642"
        y2="98.469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_254_1362"
        x1="328.997"
        y1="-22.4671"
        x2="156.981"
        y2="166.047"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_254_1362"
        x1="374.934"
        y1="-65.0029"
        x2="271.606"
        y2="59.3555"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_254_1362"
        x1="352.236"
        y1="-90.4031"
        x2="248.908"
        y2="33.9554"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_254_1362"
        x1="409.259"
        y1="-73.7876"
        x2="305.932"
        y2="50.5708"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_254_1362"
        x1="355.819"
        y1="-65.7202"
        x2="252.491"
        y2="58.6382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_254_1362"
        x1="378.661"
        y1="-65.819"
        x2="280.349"
        y2="48.1386"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_254_1362"
        x1="358.326"
        y1="-89.5483"
        x2="260.014"
        y2="24.4093"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_254_1362"
        x1="409.742"
        y1="-74.2814"
        x2="311.43"
        y2="39.6762"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_254_1362"
        x1="361.392"
        y1="-66.3786"
        x2="263.08"
        y2="47.579"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_254_1362"
        x1="368.109"
        y1="-65.1193"
        x2="256.854"
        y2="77.9423"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.557292" stop-color="#B8F76E" />
        <stop offset="1" stop-color="#B8F76E" stop-opacity="0.3" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_254_1362"
        x1="355.057"
        y1="-74.9272"
        x2="243.802"
        y2="68.1344"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.557292" stop-color="#B8F76E" />
        <stop offset="1" stop-color="#B8F76E" stop-opacity="0.3" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_254_1362"
        x1="335.831"
        y1="-89.988"
        x2="224.576"
        y2="53.0737"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_254_1362"
        x1="408.619"
        y1="-74.3588"
        x2="297.364"
        y2="68.7028"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.557292" stop-color="#B8F76E" />
        <stop offset="1" stop-color="#B8F76E" stop-opacity="0.3" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_254_1362"
        x1="376.963"
        y1="-67.3725"
        x2="265.708"
        y2="75.6891"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_254_1362"
        x1="409.699"
        y1="-38.1193"
        x2="298.444"
        y2="104.942"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_254_1362"
        x1="462.619"
        y1="-14.4856"
        x2="367.997"
        y2="86.0758"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_254_1362"
        x1="445.486"
        y1="-36.5054"
        x2="350.864"
        y2="64.056"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_254_1362"
        x1="489.49"
        y1="-22.8477"
        x2="394.867"
        y2="77.7138"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#B8F76E" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_254_1362"
        x1="447.771"
        y1="-14.7809"
        x2="353.148"
        y2="85.7805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_254_1362"
        x1="406"
        y1="434"
        x2="214.14"
        y2="507"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFEFE5" />
        <stop offset="0.589169" stop-color="#FF9654" />
        <stop offset="1" stop-color="#FFDFC7" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_254_1362"
        x1="8"
        y1="433.236"
        x2="199.86"
        y2="506.236"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFEFE5" />
        <stop offset="0.589169" stop-color="#FF9654" />
        <stop offset="1" stop-color="#FFDFC7" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_254_1362"
        x1="258.5"
        y1="423"
        x2="192"
        y2="506.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#FFEBCB" />
      </linearGradient>
      <linearGradient
        id="paint39_linear_254_1362"
        x1="172.04"
        y1="485.21"
        x2="172.04"
        y2="498.614"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD964" />
        <stop offset="1" stop-color="#FFF9D0" />
      </linearGradient>
    </defs>
  </svg>
);

export const QuickEnableIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_225_528)">
      <path
        d="M2 9.5C2 7.568 3.568 6 5.5 6H26.5C28.432 6 30 7.568 30 9.5V22.5C30 23.4283 29.6313 24.3185 28.9749 24.9749C28.3185 25.6313 27.4283 26 26.5 26H5.5C4.57174 26 3.6815 25.6313 3.02513 24.9749C2.36875 24.3185 2 23.4283 2 22.5V9.5Z"
        fill="url(#paint0_linear_225_528)"
      />
      <path
        d="M19 12C18.7348 12 18.4804 12.1054 18.2929 12.2929C18.1054 12.4804 18 12.7348 18 13C18 13.2652 18.1054 13.5196 18.2929 13.7071C18.4804 13.8946 18.7348 14 19 14H25C25.2652 14 25.5196 13.8946 25.7071 13.7071C25.8946 13.5196 26 13.2652 26 13C26 12.7348 25.8946 12.4804 25.7071 12.2929C25.5196 12.1054 25.2652 12 25 12H19ZM19 18C18.7348 18 18.4804 18.1054 18.2929 18.2929C18.1054 18.4804 18 18.7348 18 19C18 19.2652 18.1054 19.5196 18.2929 19.7071C18.4804 19.8946 18.7348 20 19 20H20.2C20.4652 20 20.7196 19.8946 20.9071 19.7071C21.0946 19.5196 21.2 19.2652 21.2 19C21.2 18.7348 21.0946 18.4804 20.9071 18.2929C20.7196 18.1054 20.4652 18 20.2 18H19Z"
        fill="#FF271F"
      />
      <path
        d="M7.716 16.784C7.26121 16.7851 6.82536 16.9662 6.50377 17.2878C6.18219 17.6094 6.00106 18.0452 6 18.5C6.00007 19.2448 6.24909 19.9683 6.70751 20.5553C7.16592 21.1424 7.8074 21.5594 8.53 21.74L8.636 21.768C9.876 22.078 11.17 22.078 12.408 21.768L12.516 21.742C13.2386 21.5614 13.8801 21.1444 14.3385 20.5573C14.7969 19.9703 15.0459 19.2468 15.046 18.502C15.0455 18.0469 14.8646 17.6105 14.5429 17.2885C14.2213 16.9665 13.7851 16.7851 13.33 16.784H7.716Z"
        fill="#FF271F"
      />
      <path
        d="M10.522 15.428C10.8784 15.428 11.2313 15.3578 11.5606 15.2214C11.8899 15.085 12.1891 14.8851 12.4411 14.6331C12.6931 14.3811 12.893 14.0819 13.0294 13.7526C13.1658 13.4233 13.236 13.0704 13.236 12.714C13.236 12.3576 13.1658 12.0047 13.0294 11.6754C12.893 11.3461 12.6931 11.0469 12.4411 10.7949C12.1891 10.5429 11.8899 10.343 11.5606 10.2066C11.2313 10.0702 10.8784 10 10.522 10C9.8022 10 9.11189 10.2859 8.60291 10.7949C8.09394 11.3039 7.808 11.9942 7.808 12.714C7.808 13.4338 8.09394 14.1241 8.60291 14.6331C9.11189 15.1421 9.8022 15.428 10.522 15.428Z"
        fill="#FF271F"
      />
      <path
        d="M31.8448 23.0371L23.6522 31.8149C23.5654 31.9076 23.4508 31.9695 23.3257 31.9913C23.2006 32.0131 23.0718 31.9936 22.9588 31.9358C22.8457 31.878 22.7545 31.785 22.699 31.6708C22.6434 31.5567 22.6265 31.4275 22.6508 31.3029L23.7232 25.9389L19.5076 24.356C19.4171 24.3221 19.3363 24.2663 19.2726 24.1936C19.2089 24.121 19.1642 24.0336 19.1424 23.9394C19.1207 23.8453 19.1226 23.7472 19.1481 23.6539C19.1735 23.5606 19.2216 23.4751 19.2882 23.405L27.4808 14.6272C27.5676 14.5345 27.6822 14.4726 27.8073 14.4508C27.9324 14.429 28.0612 14.4485 28.1742 14.5063C28.2873 14.5641 28.3785 14.6571 28.434 14.7713C28.4896 14.8855 28.5065 15.0146 28.4822 15.1392L27.4069 20.5091L31.6225 22.0898C31.7123 22.1239 31.7924 22.1796 31.8557 22.252C31.9189 22.3244 31.9633 22.4113 31.985 22.5049C32.0067 22.5985 32.005 22.6961 31.98 22.7889C31.9551 22.8817 31.9076 22.967 31.8419 23.0371H31.8448Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_225_528" x1="12" y1="6" x2="17.878" y2="26.324" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FDB574" />
      </linearGradient>
      <clipPath id="clip0_225_528">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LicensedFirmIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_225_546)">
      <path
        d="M16 3.03404C16.0003 2.5376 15.8774 2.04885 15.6423 1.6116C15.4072 1.17435 15.0673 0.802272 14.653 0.528729C14.2388 0.255187 13.7631 0.0887281 13.2686 0.0442774C12.7742 -0.000173334 12.2764 0.0787735 11.82 0.27404L3.028 4.04404C2.12931 4.42975 1.36347 5.07053 0.825266 5.88708C0.287064 6.70363 0.000136358 7.66008 5.47605e-07 8.63804V16.966C-0.000299372 17.4625 0.122603 17.9512 0.357689 18.3885C0.592774 18.8257 0.932695 19.1978 1.34697 19.4713C1.76125 19.7449 2.23694 19.9114 2.73138 19.9558C3.22583 20.0003 3.72358 19.9213 4.18 19.726L14.18 15.438C14.7197 15.2071 15.1799 14.8229 15.5034 14.333C15.8269 13.8431 15.9996 13.2691 16 12.682V3.03404Z"
        fill="url(#paint0_linear_225_546)"
      />
      <path
        d="M22 7.03404C22.0003 6.5376 21.8774 6.04885 21.6423 5.6116C21.4072 5.17435 21.0673 4.80227 20.653 4.52873C20.2388 4.25519 19.7631 4.08873 19.2686 4.04428C18.7742 3.99983 18.2764 4.07877 17.82 4.27404L9.028 8.04404C8.12931 8.42975 7.36347 9.07053 6.82527 9.88708C6.28706 10.7036 6.00014 11.6601 6 12.638V20.966C5.9997 21.4625 6.1226 21.9512 6.35769 22.3885C6.59277 22.8257 6.93269 23.1978 7.34697 23.4713C7.76125 23.7449 8.23694 23.9114 8.73138 23.9558C9.22583 24.0003 9.72358 23.9213 10.18 23.726L20.18 19.438C20.7197 19.2071 21.1799 18.8229 21.5034 18.333C21.8269 17.8431 21.9996 17.2691 22 16.682V7.03404Z"
        fill="url(#paint1_linear_225_546)"
      />
      <path
        d="M28 11.034C28.0003 10.5376 27.8774 10.0488 27.6423 9.6116C27.4072 9.17435 27.0673 8.80227 26.653 8.52873C26.2388 8.25519 25.7631 8.08873 25.2686 8.04428C24.7742 7.99983 24.2764 8.07877 23.82 8.27404L15.028 12.044C14.1293 12.4297 13.3635 13.0705 12.8253 13.8871C12.2871 14.7036 12.0001 15.6601 12 16.638V24.966C11.9997 25.4625 12.1226 25.9512 12.3577 26.3885C12.5928 26.8257 12.9327 27.1978 13.347 27.4713C13.7613 27.7449 14.2369 27.9114 14.7314 27.9558C15.2258 28.0003 15.7236 27.9213 16.18 27.726L26.18 23.438C26.7197 23.2071 27.1799 22.8229 27.5034 22.333C27.8269 21.8431 27.9996 21.2691 28 20.682V11.034Z"
        fill="url(#paint2_linear_225_546)"
      />
      <path
        d="M32 27C32 29.49 30 32 25 32C20 32 18 29.5 18 27C18 26.2044 18.3161 25.4413 18.8787 24.8787C19.4413 24.3161 20.2044 24 21 24H29C29.7956 24 30.5587 24.3161 31.1213 24.8787C31.6839 25.4413 32 26.2044 32 27Z"
        fill="white"
      />
      <path
        d="M29 18C29 19.0609 28.5786 20.0783 27.8284 20.8284C27.0783 21.5786 26.0609 22 25 22C23.9391 22 22.9217 21.5786 22.1716 20.8284C21.4214 20.0783 21 19.0609 21 18C21 16.9391 21.4214 15.9217 22.1716 15.1716C22.9217 14.4214 23.9391 14 25 14C26.0609 14 27.0783 14.4214 27.8284 15.1716C28.5786 15.9217 29 16.9391 29 18Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_225_546"
        x1="5.71429"
        y1="0.0322266"
        x2="14.5426"
        y2="17.5315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFF9EB" />
        <stop offset="1" stop-color="#FC8C28" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_225_546"
        x1="11.7143"
        y1="4.03223"
        x2="20.5426"
        y2="21.5315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFCF4" />
        <stop offset="1" stop-color="#FF8D26" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_225_546"
        x1="17.7143"
        y1="8.03223"
        x2="26.5426"
        y2="25.5315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFFFD" />
        <stop offset="0.740385" stop-color="#FFA452" />
      </linearGradient>
      <clipPath id="clip0_225_546">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SafeIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.6665 7.33321V9.33321H11.3332V7.33321C11.3332 6.36075 11.7195 5.42812 12.4071 4.74049C13.0947 4.05285 14.0274 3.66654 14.9998 3.66654C15.9723 3.66654 16.9049 4.05285 17.5926 4.74049C18.2802 5.42812 18.6665 6.36075 18.6665 7.33321V9.33321H20.3332V7.33321C20.3332 5.91872 19.7713 4.56217 18.7711 3.56197C17.7709 2.56178 16.4143 1.99988 14.9998 1.99988C13.5853 1.99988 12.2288 2.56178 11.2286 3.56197C10.2284 4.56217 9.6665 5.91872 9.6665 7.33321Z"
      fill="url(#paint0_linear_225_497)"
    />
    <path
      d="M25.6666 12.8332C25.6666 11.7281 25.2276 10.6683 24.4462 9.88689C23.6648 9.10549 22.605 8.6665 21.4999 8.6665H8.49992C7.39485 8.6665 6.33504 9.10549 5.55364 9.88689C4.77224 10.6683 4.33325 11.7281 4.33325 12.8332V23.1665C4.33325 24.2716 4.77224 25.3314 5.55364 26.1128C6.33504 26.8942 7.39485 27.3332 8.49992 27.3332H21.4999C22.605 27.3332 23.6648 26.8942 24.4462 26.1128C25.2276 25.3314 25.6666 24.2716 25.6666 23.1665V12.8332Z"
      fill="url(#paint1_linear_225_497)"
    />
    <path
      d="M27.6666 12.8332C27.6666 11.7281 27.2276 10.6683 26.4462 9.88689C25.6648 9.10549 24.605 8.6665 23.4999 8.6665H6.49992C5.39485 8.6665 4.33504 9.10549 3.55364 9.88689C2.77224 10.6683 2.33325 11.7281 2.33325 12.8332V23.1665C2.33325 24.2716 2.77224 25.3314 3.55364 26.1128C4.33504 26.8942 5.39485 27.3332 6.49992 27.3332H23.4999C24.605 27.3332 25.6648 26.8942 26.4462 26.1128C27.2276 25.3314 27.6666 24.2716 27.6666 23.1665V12.8332Z"
      fill="url(#paint2_linear_225_497)"
    />
    <path
      d="M26.7039 17.1819C26.0619 16.9897 25.4413 16.7321 24.8519 16.4133C24.3227 16.1274 23.8151 15.8032 23.3333 15.4433C23.2368 15.3718 23.1199 15.3333 22.9999 15.3333C22.8799 15.3333 22.763 15.3718 22.6666 15.4433C20.7833 16.8413 18.8619 17.5333 16.8886 17.5333C16.7421 17.5327 16.6013 17.5903 16.4972 17.6934C16.3931 17.7966 16.3341 17.9367 16.3333 18.0833V21.9333C16.3337 23.1395 16.5693 24.2395 17.0399 25.2333C17.359 25.9031 17.777 26.5211 18.2799 27.0666C19.3506 28.2399 20.8599 29.2066 22.7966 29.9619C22.9274 30.0129 23.0725 30.0129 23.2033 29.9619C27.4759 28.2953 29.6666 25.5999 29.6666 21.9333V18.0833C29.6657 17.9367 29.6067 17.7966 29.5026 17.6934C29.3985 17.5903 29.2578 17.5327 29.1113 17.5333C28.3001 17.5333 27.4977 17.4162 26.7039 17.1819Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_225_497"
        x1="13.476"
        y1="1.99988"
        x2="15.5623"
        y2="9.49459"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FDB574" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_225_497"
        x1="27.1906"
        y1="28.4998"
        x2="7.72259"
        y2="10.3705"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF6F47" />
        <stop offset="1" stop-color="#FFCD0F" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_225_497"
        x1="11.9523"
        y1="8.6665"
        x2="18.4228"
        y2="26.9298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FDB574" />
      </linearGradient>
    </defs>
  </svg>
);

export const OpenAccountIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 11.875C2.5 9.46 4.46 7.5 6.875 7.5H33.125C35.54 7.5 37.5 9.46 37.5 11.875V28.125C37.5 29.2853 37.0391 30.3981 36.2186 31.2186C35.3981 32.0391 34.2853 32.5 33.125 32.5H6.875C5.71468 32.5 4.60188 32.0391 3.78141 31.2186C2.96094 30.3981 2.5 29.2853 2.5 28.125V11.875Z"
      fill="url(#paint0_linear_236_453)"
    />
    <path
      d="M23.75 15C23.4185 15 23.1005 15.1317 22.8661 15.3661C22.6317 15.6005 22.5 15.9185 22.5 16.25C22.5 16.5815 22.6317 16.8995 22.8661 17.1339C23.1005 17.3683 23.4185 17.5 23.75 17.5H31.25C31.5815 17.5 31.8995 17.3683 32.1339 17.1339C32.3683 16.8995 32.5 16.5815 32.5 16.25C32.5 15.9185 32.3683 15.6005 32.1339 15.3661C31.8995 15.1317 31.5815 15 31.25 15H23.75ZM23.75 22.5C23.4185 22.5 23.1005 22.6317 22.8661 22.8661C22.6317 23.1005 22.5 23.4185 22.5 23.75C22.5 24.0815 22.6317 24.3995 22.8661 24.6339C23.1005 24.8683 23.4185 25 23.75 25H25.25C25.5815 25 25.8995 24.8683 26.1339 24.6339C26.3683 24.3995 26.5 24.0815 26.5 23.75C26.5 23.4185 26.3683 23.1005 26.1339 22.8661C25.8995 22.6317 25.5815 22.5 25.25 22.5H23.75Z"
      fill="#EA9447"
    />
    <path
      d="M9.645 20.98C9.07652 20.9813 8.53169 21.2077 8.12971 21.6097C7.72774 22.0117 7.50132 22.5565 7.5 23.125C7.50008 24.056 7.81137 24.9603 8.38438 25.6942C8.9574 26.428 9.75925 26.9492 10.6625 27.175L10.795 27.21C12.345 27.5975 13.9625 27.5975 15.51 27.21L15.645 27.1775C16.5482 26.9517 17.3501 26.4305 17.9231 25.6967C18.4961 24.9628 18.8074 24.0585 18.8075 23.1275C18.8068 22.5586 18.5807 22.0131 18.1787 21.6106C17.7766 21.2081 17.2314 20.9813 16.6625 20.98H9.645Z"
      fill="#EA9447"
    />
    <path
      d="M13.1525 19.285C13.598 19.285 14.0392 19.1972 14.4508 19.0268C14.8624 18.8563 15.2363 18.6064 15.5514 18.2914C15.8664 17.9763 16.1163 17.6024 16.2868 17.1908C16.4573 16.7792 16.545 16.338 16.545 15.8925C16.545 15.447 16.4573 15.0058 16.2868 14.5942C16.1163 14.1826 15.8664 13.8087 15.5514 13.4936C15.2363 13.1786 14.8624 12.9287 14.4508 12.7582C14.0392 12.5877 13.598 12.5 13.1525 12.5C12.2528 12.5 11.3899 12.8574 10.7536 13.4936C10.1174 14.1299 9.76 14.9928 9.76 15.8925C9.76 16.7922 10.1174 17.6551 10.7536 18.2914C11.3899 18.9276 12.2528 19.285 13.1525 19.285Z"
      fill="#EA9447"
    />
    <defs>
      <linearGradient
        id="paint0_linear_236_453"
        x1="15"
        y1="7.5"
        x2="22.3475"
        y2="32.905"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FDB574" />
      </linearGradient>
    </defs>
  </svg>
);

export const DepositFundsIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M37.5 20.67C37.5 24.55 36.13 27.27 34.725 29.02C34.0819 29.8248 33.3335 30.5395 32.5 31.145V33.75C32.5 34.7445 32.1049 35.6983 31.4017 36.4016C30.6984 37.1049 29.7446 37.5 28.75 37.5H27.5C26.837 37.5 26.2011 37.2366 25.7322 36.7677C25.2634 36.2989 25 35.663 25 35H20C20 35.663 19.7366 36.2989 19.2678 36.7677C18.7989 37.2366 18.163 37.5 17.5 37.5H16.25C15.2554 37.5 14.3016 37.1049 13.5983 36.4016C12.8951 35.6983 12.5 34.7445 12.5 33.75V33.215C9.0925 32.1325 6.72 29.38 5.55 26.07C5.501 25.9082 5.41458 25.7604 5.29773 25.6383C5.18089 25.5163 5.03692 25.4235 4.8775 25.3675C4.19385 25.1726 3.59214 24.7607 3.16324 24.1938C2.73435 23.6269 2.50155 22.9358 2.5 22.225V20.24C2.5 18.8 3.455 17.535 4.8375 17.14C5.0975 17.065 5.3775 16.815 5.515 16.3975C6.38 13.7825 8.1875 11.8725 10.515 10.4725C10.7567 10.3258 10.9733 10.2008 11.165 10.0975V5.40745C11.1665 5.02748 11.2818 4.65668 11.4962 4.34294C11.7106 4.0292 12.0141 3.78694 12.3675 3.64745C12.7111 3.50344 13.0891 3.46222 13.4556 3.52878C13.8221 3.59534 14.1615 3.76684 14.4325 4.02245C15.065 4.62245 15.895 5.33495 16.7825 5.91745C17.695 6.51245 18.55 6.89245 19.2475 6.96245H19.26C27.6925 6.95995 37.5 11.1775 37.5 20.67Z"
      fill="url(#paint0_linear_239_460)"
    />
    <path
      d="M13.75 16.875C13.75 17.3723 13.5525 17.8492 13.2008 18.2008C12.8492 18.5525 12.3723 18.75 11.875 18.75C11.3777 18.75 10.9008 18.5525 10.5492 18.2008C10.1975 17.8492 10 17.3723 10 16.875C10 16.3777 10.1975 15.9008 10.5492 15.5492C10.9008 15.1975 11.3777 15 11.875 15C12.3723 15 12.8492 15.1975 13.2008 15.5492C13.5525 15.9008 13.75 16.3777 13.75 16.875Z"
      fill="#EA9447"
    />
    <path
      d="M17.3549 11.8175C17.5663 11.3061 17.972 10.8995 18.483 10.6872C18.994 10.4748 19.5683 10.474 20.0799 10.685L33.9799 16.4225C34.4918 16.6337 34.8988 17.0395 35.1114 17.5508C35.324 18.0621 35.3248 18.6369 35.1136 19.1487C34.9025 19.6606 34.4966 20.0676 33.9853 20.2802C33.4741 20.4928 32.8993 20.4937 32.3874 20.2825L18.4874 14.5425C17.976 14.3311 17.5695 13.9254 17.3571 13.4144C17.1448 12.9034 17.144 12.329 17.3549 11.8175Z"
      fill="#EA9447"
    />
    <path
      d="M30.3499 19.4399C31.7242 18.8752 32.8999 17.915 33.7277 16.6811C34.5555 15.4472 34.9982 13.9952 34.9995 12.5094C35.0008 11.0235 34.5608 9.57071 33.7351 8.33533C32.9095 7.09995 31.7356 6.13765 30.3622 5.57051C28.9888 5.00337 27.4779 4.85695 26.0212 5.14982C24.5645 5.4427 23.2276 6.16167 22.1801 7.21553C21.1327 8.26939 20.4218 9.61063 20.1378 11.0691C19.8538 12.5276 20.0094 14.0375 20.5849 15.4074L30.3499 19.4399Z"
      fill="url(#paint1_linear_239_460)"
    />
    <path
      d="M30.3499 19.4399C31.7242 18.8752 32.8999 17.915 33.7277 16.6811C34.5555 15.4472 34.9982 13.9952 34.9995 12.5094C35.0008 11.0235 34.5608 9.57071 33.7351 8.33533C32.9095 7.09995 31.7356 6.13765 30.3622 5.57051C28.9888 5.00337 27.4779 4.85695 26.0212 5.14982C24.5645 5.4427 23.2276 6.16167 22.1801 7.21553C21.1327 8.26939 20.4218 9.61063 20.1378 11.0691C19.8538 12.5276 20.0094 14.0375 20.5849 15.4074L30.3499 19.4399Z"
      fill="url(#paint2_linear_239_460)"
      fill-opacity="0.8"
    />
    <defs>
      <linearGradient
        id="paint0_linear_239_460"
        x1="15"
        y1="3.4978"
        x2="27.755"
        y2="35.9237"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FFA758" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_239_460"
        x1="25.3567"
        y1="5.00269"
        x2="30.7355"
        y2="18.8048"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FDB574" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_239_460"
        x1="29.4874"
        y1="5.90244"
        x2="23.7199"
        y2="18.5524"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.67" stop-color="#FB5937" stop-opacity="0" />
        <stop offset="1" stop-color="#CD3E1D" />
      </linearGradient>
    </defs>
  </svg>
);

export const StartInvestingIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.145 5.75002C14.8675 5.61252 15.5 6.19252 15.5 6.92752V18.0025C15.5007 18.6651 15.7643 19.3004 16.2331 19.7687C16.7019 20.237 17.3374 20.5 18 20.5H29.075C29.8075 20.5 30.3875 21.1325 30.25 21.855C29.5954 25.2072 27.7168 28.1958 24.9799 30.2392C22.243 32.2825 18.8437 33.2343 15.4437 32.9092C12.0437 32.5842 8.88635 31.0056 6.58618 28.4808C4.28601 25.9559 3.00767 22.6655 3 19.25C3.00023 16.0555 4.11275 12.9607 6.14651 10.4972C8.18026 8.03374 11.0083 6.35524 14.145 5.75002Z"
      fill="url(#paint0_linear_239_467)"
    />
    <path
      d="M33.0002 16.935V16.9225C32.9999 15.0938 32.6394 13.2832 31.9393 11.5938C31.2392 9.90449 30.2132 8.36959 28.9199 7.07677C27.6266 5.78395 26.0914 4.75851 24.4018 4.05902C22.7122 3.35953 20.9014 2.99967 19.0727 3C18.9292 3.00227 18.7874 3.0329 18.6557 3.0901C18.524 3.14731 18.4049 3.22998 18.3053 3.33335C18.2056 3.43673 18.1274 3.55878 18.075 3.69249C18.0227 3.8262 17.9973 3.96894 18.0002 4.1125V16.75C18.0002 17.0815 18.1319 17.3995 18.3664 17.6339C18.6008 17.8683 18.9187 18 19.2502 18H31.8927C32.4927 18 33.0002 17.535 33.0002 16.935Z"
      fill="url(#paint1_linear_239_467)"
    />
    <path
      d="M32 17C32 16.337 32.2634 15.7011 32.7322 15.2322C33.2011 14.7634 33.837 14.5 34.5 14.5C35.163 14.5 35.7989 14.7634 36.2678 15.2322C36.7366 15.7011 37 16.337 37 17V34.5C37 35.163 36.7366 35.7989 36.2678 36.2678C35.7989 36.7366 35.163 37 34.5 37C33.837 37 33.2011 36.7366 32.7322 36.2678C32.2634 35.7989 32 35.163 32 34.5V17Z"
      fill="url(#paint2_linear_239_467)"
    />
    <path
      d="M24.5 22C24.5 21.337 24.7634 20.7011 25.2322 20.2322C25.7011 19.7634 26.337 19.5 27 19.5C27.663 19.5 28.2989 19.7634 28.7678 20.2322C29.2366 20.7011 29.5 21.337 29.5 22V34.5C29.5 35.163 29.2366 35.7989 28.7678 36.2678C28.2989 36.7366 27.663 37 27 37C26.337 37 25.7011 36.7366 25.2322 36.2678C24.7634 35.7989 24.5 35.163 24.5 34.5V22Z"
      fill="url(#paint3_linear_239_467)"
    />
    <path
      d="M17 27C17 26.337 17.2634 25.7011 17.7322 25.2322C18.2011 24.7634 18.837 24.5 19.5 24.5C20.163 24.5 20.7989 24.7634 21.2678 25.2322C21.7366 25.7011 22 26.337 22 27V34.5C22 35.163 21.7366 35.7989 21.2678 36.2678C20.7989 36.7366 20.163 37 19.5 37C18.837 37 18.2011 36.7366 17.7322 36.2678C17.2634 35.7989 17 35.163 17 34.5V27Z"
      fill="url(#paint4_linear_239_467)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_239_467"
        x1="12.7394"
        y1="5.72974"
        x2="23.1673"
        y2="31.5107"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FFA758" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_239_467"
        x1="23.3572"
        y1="3"
        x2="29.1033"
        y2="17.1915"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FFA758" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_239_467"
        x1="33.7857"
        y1="14.5"
        x2="44.2362"
        y2="20.2356"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FFA758" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_239_467"
        x1="26.2857"
        y1="19.5"
        x2="35.3639"
        y2="25.9059"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FFA758" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_239_467"
        x1="18.7857"
        y1="24.5"
        x2="25.6677"
        y2="31.2987"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFAEC" />
        <stop offset="1" stop-color="#FFA758" />
      </linearGradient>
    </defs>
  </svg>
);

// 市场001-港股ETF
export const Market001Icon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="9" stroke="#1B212D" stroke-width="1.25" />
    <path
      d="M15.1585 12.3104C15.5521 11.6975 16.4479 11.6975 16.8415 12.3104L17.8374 13.8615C17.915 13.9823 18.0177 14.085 18.1385 14.1626L19.6896 15.1585C20.3025 15.5521 20.3025 16.4479 19.6896 16.8415L18.1385 17.8374C18.0177 17.915 17.915 18.0177 17.8374 18.1385L16.8415 19.6896C16.4479 20.3025 15.5521 20.3025 15.1585 19.6896L14.1626 18.1385C14.085 18.0177 13.9823 17.915 13.8615 17.8374L12.3104 16.8415C11.6975 16.4479 11.6975 15.5521 12.3104 15.1585L13.8615 14.1626C13.9823 14.085 14.085 13.9823 14.1626 13.8615L15.1585 12.3104Z"
      stroke="#FF4000"
      stroke-width="1.25"
    />
  </svg>
);

// 市场002-区间涨跌幅
export const Market002Icon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 17.5323C7 17.1996 7.16555 16.8886 7.44162 16.7028L12.8384 13.0703C13.3035 12.7573 13.9349 12.8876 14.238 13.3591L15.7217 15.667C16.0182 16.1284 16.6311 16.2648 17.0953 15.9727L23.4675 11.9641C24.1335 11.5451 25 12.0238 25 12.8105V23C25 23.5523 24.5523 24 24 24H8C7.44772 24 7 23.5523 7 23V17.5323Z"
      stroke="#1B212D"
      stroke-width="1.25"
    />
    <path
      d="M7 14L13.7129 9.52474C14.1545 9.23034 14.7492 9.3322 15.0676 9.75679L16.9401 12.2535C17.2554 12.6739 17.8422 12.7785 18.2834 12.4931L24.5785 8.41978C24.9968 8.14911 24.8051 7.5 24.3069 7.5H22"
      stroke="#FF4000"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
);

// 市场003-创业板
export const Market003Icon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 23.5H26" stroke="#1B212D" stroke-width="1.25" stroke-linecap="round" />
    <path
      d="M8 23.5V12.2599C8 11.4502 8.48831 10.7203 9.23682 10.4113L14.7368 8.14072C16.0534 7.5972 17.5 8.56503 17.5 9.98938V23.5"
      stroke="#1B212D"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path
      d="M18 13.5H22C23.1046 13.5 24 14.3954 24 15.5V23"
      stroke="#1B212D"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path d="M11 15H15" stroke="#FF4000" stroke-width="1.25" stroke-linecap="round" />
    <path d="M11 17.5H15" stroke="#FF4000" stroke-width="1.25" stroke-linecap="round" />
  </svg>
);

// 市场004-港股ADR
export const Market004Icon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 6V8.5C8.5 9.05228 8.05228 9.5 7.5 9.5H7C6.44772 9.5 6 9.94772 6 10.5V17M8 21V18.5C8 17.9477 8.44772 17.5 9 17.5H9.5C10.0523 17.5 10.5 17.0523 10.5 16.5V10"
      stroke="#1B212D"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path
      d="M16.5 11V13.5C16.5 14.0523 16.0523 14.5 15.5 14.5H15C14.4477 14.5 14 14.9477 14 15.5V22M16 26V23.5C16 22.9477 16.4477 22.5 17 22.5H17.5C18.0523 22.5 18.5 22.0523 18.5 21.5V15"
      stroke="#FF4000"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path
      d="M24.5 8V10.5C24.5 11.0523 24.0523 11.5 23.5 11.5H23C22.4477 11.5 22 11.9477 22 12.5V19M24 23V20.5C24 19.9477 24.4477 19.5 25 19.5H25.5C26.0523 19.5 26.5 19.0523 26.5 18.5V12"
      stroke="#1B212D"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
);

// 市场005-新股认购
export const Market005Icon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="7" width="20" height="14" rx="2" stroke="#1B212D" stroke-width="1.25" />
    <path d="M11 24H21" stroke="#1B212D" stroke-width="1.25" stroke-linecap="round" />
    <path d="M11.5 18V13" stroke="#FF4000" stroke-width="1.25" stroke-linecap="round" />
    <path d="M15.5 18V11" stroke="#FF4000" stroke-width="1.25" stroke-linecap="round" />
    <path d="M19.5 18V15" stroke="#FF4000" stroke-width="1.25" stroke-linecap="round" />
  </svg>
);

// 市场006-图表
export const Market006Icon = () => (
  <svg width="390" height="154" viewBox="0 0 390 154" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M79.102 77.72C79.762 77.72 80.3053 77.91 80.732 78.29C81.1586 78.6767 81.372 79.18 81.372 79.8C81.372 80.4133 81.1386 80.9733 80.672 81.48C80.3986 81.7667 79.9053 82.15 79.192 82.63C78.2853 83.2367 77.7653 83.7833 77.632 84.27H81.382V85H76.622C76.622 84.34 76.8586 83.75 77.332 83.23C77.6386 82.8833 78.1553 82.46 78.882 81.96C79.4486 81.5533 79.822 81.2567 80.002 81.07C80.3686 80.67 80.552 80.2433 80.552 79.79C80.552 79.3567 80.422 79.02 80.162 78.78C79.902 78.54 79.5386 78.42 79.072 78.42C78.572 78.42 78.1953 78.5867 77.942 78.92C77.6553 79.2467 77.5086 79.7233 77.502 80.35H76.682C76.682 79.5567 76.9053 78.92 77.352 78.44C77.792 77.96 78.3753 77.72 79.102 77.72Z"
      fill="#888F97"
    />
    <rect x="73" y="91" width="12" height="1" fill="#FF295A" />
    <path
      d="M78.06 99.42V100.14L72.92 101.75L78.06 103.36V104.09L71.82 102.12V101.38L78.06 99.42ZM71.82 102.95L78.06 104.91V105.59L71.82 103.63V102.95ZM79.2809 103.07H84.3309V103.75H79.2809V103.07ZM71.66 112.86H76.35V113.53L73.72 120H72.85L75.51 113.61H71.66V112.86Z"
      fill="#A2A7AD"
    />
    <path
      d="M108.102 90.72C109.422 90.72 110.182 91.3567 110.382 92.63H109.572C109.412 91.8167 108.919 91.41 108.092 91.41C107.525 91.41 107.085 91.6867 106.772 92.24C106.459 92.7467 106.302 93.4133 106.302 94.24C106.302 94.3267 106.305 94.4133 106.312 94.5H106.352C106.539 94.12 106.795 93.8333 107.122 93.64C107.435 93.4333 107.805 93.33 108.232 93.33C108.912 93.33 109.462 93.55 109.882 93.99C110.295 94.4367 110.502 95.0033 110.502 95.69C110.502 96.39 110.275 96.9733 109.822 97.44C109.355 97.9067 108.779 98.14 108.092 98.14C107.232 98.14 106.579 97.8167 106.132 97.17C105.719 96.57 105.512 95.72 105.512 94.62C105.512 93.4733 105.735 92.5467 106.182 91.84C106.649 91.0933 107.289 90.72 108.102 90.72ZM108.072 94.01C107.605 94.01 107.215 94.17 106.902 94.49C106.595 94.8033 106.442 95.21 106.442 95.71C106.442 96.2167 106.589 96.6267 106.882 96.94C107.182 97.28 107.579 97.45 108.072 97.45C108.545 97.45 108.935 97.2867 109.242 96.96C109.542 96.62 109.692 96.1967 109.692 95.69C109.692 95.19 109.545 94.7867 109.252 94.48C108.959 94.1667 108.565 94.01 108.072 94.01Z"
      fill="#888F97"
    />
    <rect x="102" y="104" width="12" height="2" fill="#FF295A" />
    <path
      d="M94 117.07H99.05V117.75H94V117.07ZM100.115 112.86H104.805V113.53L102.175 120H101.305L103.965 113.61H100.115V112.86ZM106.821 115.65C107.141 115.65 107.517 115.797 107.951 116.09C108.391 116.377 108.701 116.52 108.881 116.52C109.101 116.52 109.364 116.287 109.671 115.82L110.171 116.18C109.737 116.833 109.307 117.16 108.881 117.16C108.574 117.16 108.204 117.013 107.771 116.72C107.337 116.433 107.021 116.29 106.821 116.29C106.587 116.29 106.324 116.52 106.031 116.98L105.531 116.63C105.944 115.977 106.374 115.65 106.821 115.65ZM110.751 117.07H115.801V117.75H110.751V117.07ZM117.255 112.86H121.405V113.59H117.925L117.685 115.98H117.725C117.925 115.74 118.182 115.56 118.495 115.44C118.762 115.327 119.065 115.27 119.405 115.27C120.085 115.27 120.635 115.483 121.055 115.91C121.482 116.357 121.695 116.96 121.695 117.72C121.695 118.44 121.439 119.03 120.925 119.49C120.439 119.923 119.845 120.14 119.145 120.14C118.512 120.14 117.975 119.97 117.535 119.63C117.042 119.25 116.769 118.733 116.715 118.08H117.525C117.565 118.533 117.745 118.88 118.065 119.12C118.352 119.333 118.715 119.44 119.155 119.44C119.655 119.44 120.069 119.28 120.395 118.96C120.722 118.633 120.885 118.223 120.885 117.73C120.885 117.17 120.732 116.73 120.425 116.41C120.139 116.097 119.732 115.94 119.205 115.94C118.865 115.94 118.562 116.013 118.295 116.16C118.009 116.3 117.795 116.513 117.655 116.8H116.875L117.255 112.86Z"
      fill="#A2A7AD"
    />
    <path
      d="M134.154 88.72C134.814 88.72 135.357 88.91 135.784 89.29C136.211 89.6767 136.424 90.18 136.424 90.8C136.424 91.4133 136.191 91.9733 135.724 92.48C135.451 92.7667 134.957 93.15 134.244 93.63C133.337 94.2367 132.817 94.7833 132.684 95.27H136.434V96H131.674C131.674 95.34 131.911 94.75 132.384 94.23C132.691 93.8833 133.207 93.46 133.934 92.96C134.501 92.5533 134.874 92.2567 135.054 92.07C135.421 91.67 135.604 91.2433 135.604 90.79C135.604 90.3567 135.474 90.02 135.214 89.78C134.954 89.54 134.591 89.42 134.124 89.42C133.624 89.42 133.247 89.5867 132.994 89.92C132.707 90.2467 132.561 90.7233 132.554 91.35H131.734C131.734 90.5567 131.957 89.92 132.404 89.44C132.844 88.96 133.427 88.72 134.154 88.72ZM138 88.86H142.15V89.59H138.67L138.43 91.98H138.47C138.67 91.74 138.927 91.56 139.24 91.44C139.507 91.3267 139.81 91.27 140.15 91.27C140.83 91.27 141.38 91.4833 141.8 91.91C142.227 92.3567 142.44 92.96 142.44 93.72C142.44 94.44 142.183 95.03 141.67 95.49C141.183 95.9233 140.59 96.14 139.89 96.14C139.257 96.14 138.72 95.97 138.28 95.63C137.787 95.25 137.513 94.7333 137.46 94.08H138.27C138.31 94.5333 138.49 94.88 138.81 95.12C139.097 95.3333 139.46 95.44 139.9 95.44C140.4 95.44 140.813 95.28 141.14 94.96C141.467 94.6333 141.63 94.2233 141.63 93.73C141.63 93.17 141.477 92.73 141.17 92.41C140.883 92.0967 140.477 91.94 139.95 91.94C139.61 91.94 139.307 92.0133 139.04 92.16C138.753 92.3 138.54 92.5133 138.4 92.8H137.62L138 88.86Z"
      fill="#888F97"
    />
    <rect x="131" y="102" width="12" height="4" fill="#FF295A" />
    <path
      d="M123 117.07H128.05V117.75H123V117.07ZM129.505 112.86H133.655V113.59H130.175L129.935 115.98H129.975C130.175 115.74 130.431 115.56 130.745 115.44C131.011 115.327 131.315 115.27 131.655 115.27C132.335 115.27 132.885 115.483 133.305 115.91C133.731 116.357 133.945 116.96 133.945 117.72C133.945 118.44 133.688 119.03 133.175 119.49C132.688 119.923 132.095 120.14 131.395 120.14C130.761 120.14 130.225 119.97 129.785 119.63C129.291 119.25 129.018 118.733 128.965 118.08H129.775C129.815 118.533 129.995 118.88 130.315 119.12C130.601 119.333 130.965 119.44 131.405 119.44C131.905 119.44 132.318 119.28 132.645 118.96C132.971 118.633 133.135 118.223 133.135 117.73C133.135 117.17 132.981 116.73 132.675 116.41C132.388 116.097 131.981 115.94 131.455 115.94C131.115 115.94 130.811 116.013 130.545 116.16C130.258 116.3 130.045 116.513 129.905 116.8H129.125L129.505 112.86ZM135.821 115.65C136.141 115.65 136.517 115.797 136.951 116.09C137.391 116.377 137.701 116.52 137.881 116.52C138.101 116.52 138.364 116.287 138.671 115.82L139.171 116.18C138.737 116.833 138.307 117.16 137.881 117.16C137.574 117.16 137.204 117.013 136.771 116.72C136.337 116.433 136.021 116.29 135.821 116.29C135.587 116.29 135.324 116.52 135.031 116.98L134.531 116.63C134.944 115.977 135.374 115.65 135.821 115.65ZM139.751 117.07H144.801V117.75H139.751V117.07ZM148.275 112.72C148.969 112.72 149.522 112.893 149.935 113.24C150.349 113.593 150.555 114.067 150.555 114.66C150.555 115.467 150.165 116 149.385 116.26C149.812 116.393 150.132 116.597 150.345 116.87C150.585 117.15 150.705 117.5 150.705 117.92C150.705 118.567 150.479 119.097 150.025 119.51C149.565 119.93 148.965 120.14 148.225 120.14C147.559 120.14 147.005 119.967 146.565 119.62C146.059 119.2 145.775 118.59 145.715 117.79H146.545C146.565 118.35 146.752 118.777 147.105 119.07C147.412 119.317 147.785 119.44 148.225 119.44C148.732 119.44 149.142 119.293 149.455 119C149.742 118.713 149.885 118.363 149.885 117.95C149.885 117.523 149.745 117.19 149.465 116.95C149.192 116.717 148.805 116.6 148.305 116.6H147.725V115.96H148.275C148.749 115.96 149.112 115.853 149.365 115.64C149.619 115.42 149.745 115.11 149.745 114.71C149.745 114.317 149.622 114.007 149.375 113.78C149.122 113.547 148.759 113.43 148.285 113.43C147.799 113.43 147.425 113.557 147.165 113.81C146.892 114.063 146.729 114.433 146.675 114.92H145.865C145.925 114.233 146.179 113.693 146.625 113.3C147.039 112.913 147.589 112.72 148.275 112.72Z"
      fill="#A2A7AD"
    />
    <path
      d="M160.176 58.72C160.869 58.72 161.423 58.8933 161.836 59.24C162.249 59.5933 162.456 60.0667 162.456 60.66C162.456 61.4667 162.066 62 161.286 62.26C161.713 62.3933 162.033 62.5967 162.246 62.87C162.486 63.15 162.606 63.5 162.606 63.92C162.606 64.5667 162.379 65.0967 161.926 65.51C161.466 65.93 160.866 66.14 160.126 66.14C159.459 66.14 158.906 65.9667 158.466 65.62C157.959 65.2 157.676 64.59 157.616 63.79H158.446C158.466 64.35 158.653 64.7767 159.006 65.07C159.313 65.3167 159.686 65.44 160.126 65.44C160.633 65.44 161.043 65.2933 161.356 65C161.643 64.7133 161.786 64.3633 161.786 63.95C161.786 63.5233 161.646 63.19 161.366 62.95C161.093 62.7167 160.706 62.6 160.206 62.6H159.626V61.96H160.176C160.649 61.96 161.013 61.8533 161.266 61.64C161.519 61.42 161.646 61.11 161.646 60.71C161.646 60.3167 161.523 60.0067 161.276 59.78C161.023 59.5467 160.659 59.43 160.186 59.43C159.699 59.43 159.326 59.5567 159.066 59.81C158.793 60.0633 158.629 60.4333 158.576 60.92H157.766C157.826 60.2333 158.079 59.6933 158.526 59.3C158.939 58.9133 159.489 58.72 160.176 58.72ZM164.052 58.86H168.202V59.59H164.722L164.482 61.98H164.522C164.722 61.74 164.979 61.56 165.292 61.44C165.559 61.3267 165.862 61.27 166.202 61.27C166.882 61.27 167.432 61.4833 167.852 61.91C168.279 62.3567 168.492 62.96 168.492 63.72C168.492 64.44 168.235 65.03 167.722 65.49C167.235 65.9233 166.642 66.14 165.942 66.14C165.309 66.14 164.772 65.97 164.332 65.63C163.839 65.25 163.565 64.7333 163.512 64.08H164.322C164.362 64.5333 164.542 64.88 164.862 65.12C165.149 65.3333 165.512 65.44 165.952 65.44C166.452 65.44 166.865 65.28 167.192 64.96C167.519 64.6333 167.682 64.2233 167.682 63.73C167.682 63.17 167.529 62.73 167.222 62.41C166.935 62.0967 166.529 61.94 166.002 61.94C165.662 61.94 165.359 62.0133 165.092 62.16C164.805 62.3 164.592 62.5133 164.452 62.8H163.672L164.052 58.86ZM169.948 58.86H174.098V59.59H170.618L170.378 61.98H170.418C170.618 61.74 170.875 61.56 171.188 61.44C171.455 61.3267 171.758 61.27 172.098 61.27C172.778 61.27 173.328 61.4833 173.748 61.91C174.175 62.3567 174.388 62.96 174.388 63.72C174.388 64.44 174.131 65.03 173.618 65.49C173.131 65.9233 172.538 66.14 171.838 66.14C171.205 66.14 170.668 65.97 170.228 65.63C169.735 65.25 169.461 64.7333 169.408 64.08H170.218C170.258 64.5333 170.438 64.88 170.758 65.12C171.045 65.3333 171.408 65.44 171.848 65.44C172.348 65.44 172.761 65.28 173.088 64.96C173.415 64.6333 173.578 64.2233 173.578 63.73C173.578 63.17 173.425 62.73 173.118 62.41C172.831 62.0967 172.425 61.94 171.898 61.94C171.558 61.94 171.255 62.0133 170.988 62.16C170.701 62.3 170.488 62.5133 170.348 62.8H169.568L169.948 58.86Z"
      fill="#888F97"
    />
    <rect x="160" y="72" width="12" height="34" fill="#FF295A" />
    <path
      d="M155 117.07H160.05V117.75H155V117.07ZM163.525 112.72C164.218 112.72 164.771 112.893 165.185 113.24C165.598 113.593 165.805 114.067 165.805 114.66C165.805 115.467 165.415 116 164.635 116.26C165.061 116.393 165.381 116.597 165.595 116.87C165.835 117.15 165.955 117.5 165.955 117.92C165.955 118.567 165.728 119.097 165.275 119.51C164.815 119.93 164.215 120.14 163.475 120.14C162.808 120.14 162.255 119.967 161.815 119.62C161.308 119.2 161.025 118.59 160.965 117.79H161.795C161.815 118.35 162.001 118.777 162.355 119.07C162.661 119.317 163.035 119.44 163.475 119.44C163.981 119.44 164.391 119.293 164.705 119C164.991 118.713 165.135 118.363 165.135 117.95C165.135 117.523 164.995 117.19 164.715 116.95C164.441 116.717 164.055 116.6 163.555 116.6H162.975V115.96H163.525C163.998 115.96 164.361 115.853 164.615 115.64C164.868 115.42 164.995 115.11 164.995 114.71C164.995 114.317 164.871 114.007 164.625 113.78C164.371 113.547 164.008 113.43 163.535 113.43C163.048 113.43 162.675 113.557 162.415 113.81C162.141 114.063 161.978 114.433 161.925 114.92H161.115C161.175 114.233 161.428 113.693 161.875 113.3C162.288 112.913 162.838 112.72 163.525 112.72ZM167.821 115.65C168.141 115.65 168.517 115.797 168.951 116.09C169.391 116.377 169.701 116.52 169.881 116.52C170.101 116.52 170.364 116.287 170.671 115.82L171.171 116.18C170.737 116.833 170.307 117.16 169.881 117.16C169.574 117.16 169.204 117.013 168.771 116.72C168.337 116.433 168.021 116.29 167.821 116.29C167.587 116.29 167.324 116.52 167.031 116.98L166.531 116.63C166.944 115.977 167.374 115.65 167.821 115.65ZM174.251 112.72C175.104 112.72 175.747 113.097 176.181 113.85C176.561 114.49 176.751 115.35 176.751 116.43C176.751 117.51 176.561 118.37 176.181 119.01C175.741 119.763 175.097 120.14 174.251 120.14C173.397 120.14 172.754 119.763 172.321 119.01C171.941 118.37 171.751 117.51 171.751 116.43C171.751 115.35 171.941 114.49 172.321 113.85C172.747 113.097 173.391 112.72 174.251 112.72ZM174.251 113.42C173.611 113.42 173.151 113.763 172.871 114.45C172.671 114.93 172.571 115.59 172.571 116.43C172.571 117.257 172.671 117.917 172.871 118.41C173.151 119.097 173.611 119.44 174.251 119.44C174.891 119.44 175.351 119.097 175.631 118.41C175.837 117.903 175.941 117.243 175.941 116.43C175.941 115.603 175.837 114.943 175.631 114.45C175.351 113.763 174.891 113.42 174.251 113.42Z"
      fill="#A2A7AD"
    />
    <path
      d="M186.258 3.72C186.918 3.72 187.461 3.91 187.888 4.29C188.314 4.67667 188.528 5.18 188.528 5.8C188.528 6.41333 188.294 6.97333 187.828 7.48C187.554 7.76667 187.061 8.15 186.348 8.63C185.441 9.23667 184.921 9.78333 184.788 10.27H188.538V11H183.778C183.778 10.34 184.014 9.75 184.488 9.23C184.794 8.88333 185.311 8.46 186.038 7.96C186.604 7.55333 186.978 7.25667 187.158 7.07C187.524 6.67 187.708 6.24333 187.708 5.79C187.708 5.35667 187.578 5.02 187.318 4.78C187.058 4.54 186.694 4.42 186.228 4.42C185.728 4.42 185.351 4.58667 185.098 4.92C184.811 5.24667 184.664 5.72333 184.658 6.35H183.838C183.838 5.55667 184.061 4.92 184.508 4.44C184.948 3.96 185.531 3.72 186.258 3.72ZM192.154 3.72C192.814 3.72 193.357 3.91 193.784 4.29C194.211 4.67667 194.424 5.18 194.424 5.8C194.424 6.41333 194.191 6.97333 193.724 7.48C193.451 7.76667 192.957 8.15 192.244 8.63C191.337 9.23667 190.817 9.78333 190.684 10.27H194.434V11H189.674C189.674 10.34 189.911 9.75 190.384 9.23C190.691 8.88333 191.207 8.46 191.934 7.96C192.501 7.55333 192.874 7.25667 193.054 7.07C193.421 6.67 193.604 6.24333 193.604 5.79C193.604 5.35667 193.474 5.02 193.214 4.78C192.954 4.54 192.591 4.42 192.124 4.42C191.624 4.42 191.247 4.58667 190.994 4.92C190.707 5.24667 190.561 5.72333 190.554 6.35H189.734C189.734 5.55667 189.957 4.92 190.404 4.44C190.844 3.96 191.427 3.72 192.154 3.72ZM198.56 3.86V11H197.74V4.86C197.3 5.31333 196.74 5.64 196.06 5.84V5.02C196.373 4.93333 196.707 4.78667 197.06 4.58C197.387 4.38 197.673 4.14 197.92 3.86H198.56ZM203.946 3.72C204.606 3.72 205.149 3.91 205.576 4.29C206.003 4.67667 206.216 5.18 206.216 5.8C206.216 6.41333 205.983 6.97333 205.516 7.48C205.243 7.76667 204.749 8.15 204.036 8.63C203.129 9.23667 202.609 9.78333 202.476 10.27H206.226V11H201.466C201.466 10.34 201.703 9.75 202.176 9.23C202.483 8.88333 202.999 8.46 203.726 7.96C204.293 7.55333 204.666 7.25667 204.846 7.07C205.213 6.67 205.396 6.24333 205.396 5.79C205.396 5.35667 205.266 5.02 205.006 4.78C204.746 4.54 204.383 4.42 203.916 4.42C203.416 4.42 203.039 4.58667 202.786 4.92C202.499 5.24667 202.353 5.72333 202.346 6.35H201.526C201.526 5.55667 201.749 4.92 202.196 4.44C202.636 3.96 203.219 3.72 203.946 3.72Z"
      fill="#888F97"
    />
    <rect x="189" y="17" width="12" height="89" fill="#888F97" />
    <path
      d="M195 112.72C195.853 112.72 196.497 113.097 196.93 113.85C197.31 114.49 197.5 115.35 197.5 116.43C197.5 117.51 197.31 118.37 196.93 119.01C196.49 119.763 195.847 120.14 195 120.14C194.147 120.14 193.503 119.763 193.07 119.01C192.69 118.37 192.5 117.51 192.5 116.43C192.5 115.35 192.69 114.49 193.07 113.85C193.497 113.097 194.14 112.72 195 112.72ZM195 113.42C194.36 113.42 193.9 113.763 193.62 114.45C193.42 114.93 193.32 115.59 193.32 116.43C193.32 117.257 193.42 117.917 193.62 118.41C193.9 119.097 194.36 119.44 195 119.44C195.64 119.44 196.1 119.097 196.38 118.41C196.587 117.903 196.69 117.243 196.69 116.43C196.69 115.603 196.587 114.943 196.38 114.45C196.1 113.763 195.64 113.42 195 113.42Z"
      fill="#A2A7AD"
    />
    <path
      d="M220.974 80.72C221.834 80.72 222.484 81.04 222.924 81.68C223.344 82.28 223.554 83.1333 223.554 84.24C223.554 85.36 223.331 86.2867 222.884 87.02C222.397 87.7667 221.757 88.14 220.964 88.14C219.637 88.14 218.877 87.5033 218.684 86.23H219.494C219.647 87.0433 220.141 87.45 220.974 87.45C221.521 87.45 221.961 87.1733 222.294 86.62C222.607 86.0867 222.764 85.42 222.764 84.62L222.754 84.36H222.714C222.534 84.72 222.277 85.0067 221.944 85.22C221.611 85.4267 221.241 85.53 220.834 85.53C220.147 85.53 219.594 85.3033 219.174 84.85C218.767 84.4233 218.564 83.8633 218.564 83.17C218.564 82.4567 218.791 81.8733 219.244 81.42C219.691 80.9533 220.267 80.72 220.974 80.72ZM220.994 81.41C220.507 81.41 220.114 81.5733 219.814 81.9C219.521 82.22 219.374 82.6433 219.374 83.17C219.374 83.6833 219.521 84.0867 219.814 84.38C220.107 84.6933 220.501 84.85 220.994 84.85C221.454 84.85 221.844 84.69 222.164 84.37C222.471 84.0433 222.624 83.6367 222.624 83.15C222.624 82.6567 222.477 82.2467 222.184 81.92C221.884 81.58 221.487 81.41 220.994 81.41ZM226.87 80.72C227.73 80.72 228.38 81.04 228.82 81.68C229.24 82.28 229.45 83.1333 229.45 84.24C229.45 85.36 229.227 86.2867 228.78 87.02C228.293 87.7667 227.653 88.14 226.86 88.14C225.533 88.14 224.773 87.5033 224.58 86.23H225.39C225.543 87.0433 226.037 87.45 226.87 87.45C227.417 87.45 227.857 87.1733 228.19 86.62C228.503 86.0867 228.66 85.42 228.66 84.62L228.65 84.36H228.61C228.43 84.72 228.173 85.0067 227.84 85.22C227.507 85.4267 227.137 85.53 226.73 85.53C226.043 85.53 225.49 85.3033 225.07 84.85C224.663 84.4233 224.46 83.8633 224.46 83.17C224.46 82.4567 224.687 81.8733 225.14 81.42C225.587 80.9533 226.163 80.72 226.87 80.72ZM226.89 81.41C226.403 81.41 226.01 81.5733 225.71 81.9C225.417 82.22 225.27 82.6433 225.27 83.17C225.27 83.6833 225.417 84.0867 225.71 84.38C226.003 84.6933 226.397 84.85 226.89 84.85C227.35 84.85 227.74 84.69 228.06 84.37C228.367 84.0433 228.52 83.6367 228.52 83.15C228.52 82.6567 228.373 82.2467 228.08 81.92C227.78 81.58 227.383 81.41 226.89 81.41Z"
      fill="#888F97"
    />
    <rect x="218" y="94" width="12" height="12" fill="#02C58D" />
    <path
      d="M218.5 112.72C219.353 112.72 219.997 113.097 220.43 113.85C220.81 114.49 221 115.35 221 116.43C221 117.51 220.81 118.37 220.43 119.01C219.99 119.763 219.347 120.14 218.5 120.14C217.647 120.14 217.003 119.763 216.57 119.01C216.19 118.37 216 117.51 216 116.43C216 115.35 216.19 114.49 216.57 113.85C216.997 113.097 217.64 112.72 218.5 112.72ZM218.5 113.42C217.86 113.42 217.4 113.763 217.12 114.45C216.92 114.93 216.82 115.59 216.82 116.43C216.82 117.257 216.92 117.917 217.12 118.41C217.4 119.097 217.86 119.44 218.5 119.44C219.14 119.44 219.6 119.097 219.88 118.41C220.087 117.903 220.19 117.243 220.19 116.43C220.19 115.603 220.087 114.943 219.88 114.45C219.6 113.763 219.14 113.42 218.5 113.42ZM222.866 115.65C223.186 115.65 223.563 115.797 223.996 116.09C224.436 116.377 224.746 116.52 224.926 116.52C225.146 116.52 225.409 116.287 225.716 115.82L226.216 116.18C225.783 116.833 225.353 117.16 224.926 117.16C224.619 117.16 224.249 117.013 223.816 116.72C223.383 116.433 223.066 116.29 222.866 116.29C222.633 116.29 222.369 116.52 222.076 116.98L221.576 116.63C221.989 115.977 222.419 115.65 222.866 115.65ZM229.366 112.72C230.059 112.72 230.613 112.893 231.026 113.24C231.439 113.593 231.646 114.067 231.646 114.66C231.646 115.467 231.256 116 230.476 116.26C230.903 116.393 231.223 116.597 231.436 116.87C231.676 117.15 231.796 117.5 231.796 117.92C231.796 118.567 231.569 119.097 231.116 119.51C230.656 119.93 230.056 120.14 229.316 120.14C228.649 120.14 228.096 119.967 227.656 119.62C227.149 119.2 226.866 118.59 226.806 117.79H227.636C227.656 118.35 227.843 118.777 228.196 119.07C228.503 119.317 228.876 119.44 229.316 119.44C229.823 119.44 230.233 119.293 230.546 119C230.833 118.713 230.976 118.363 230.976 117.95C230.976 117.523 230.836 117.19 230.556 116.95C230.283 116.717 229.896 116.6 229.396 116.6H228.816V115.96H229.366C229.839 115.96 230.203 115.853 230.456 115.64C230.709 115.42 230.836 115.11 230.836 114.71C230.836 114.317 230.713 114.007 230.466 113.78C230.213 113.547 229.849 113.43 229.376 113.43C228.889 113.43 228.516 113.557 228.256 113.81C227.983 114.063 227.819 114.433 227.766 114.92H226.956C227.016 114.233 227.269 113.693 227.716 113.3C228.129 112.913 228.679 112.72 229.366 112.72Z"
      fill="#A2A7AD"
    />
    <path
      d="M250.664 89.86V97H249.844V90.86C249.404 91.3133 248.844 91.64 248.164 91.84V91.02C248.477 90.9333 248.811 90.7867 249.164 90.58C249.491 90.38 249.777 90.14 250.024 89.86H250.664ZM255.95 89.72C256.703 89.72 257.287 89.9133 257.7 90.3C258.087 90.6533 258.28 91.09 258.28 91.61C258.28 91.99 258.19 92.31 258.01 92.57C257.803 92.8567 257.52 93.0633 257.16 93.19V93.21C257.533 93.3033 257.85 93.51 258.11 93.83C258.39 94.17 258.53 94.57 258.53 95.03C258.53 95.6633 258.31 96.17 257.87 96.55C257.403 96.9433 256.763 97.14 255.95 97.14C255.123 97.14 254.483 96.9433 254.03 96.55C253.59 96.17 253.37 95.6633 253.37 95.03C253.37 94.57 253.51 94.17 253.79 93.83C254.057 93.5033 254.373 93.2967 254.74 93.21V93.19C254.367 93.0633 254.083 92.8567 253.89 92.57C253.71 92.31 253.62 91.99 253.62 91.61C253.62 91.0833 253.813 90.6467 254.2 90.3C254.613 89.9133 255.197 89.72 255.95 89.72ZM255.95 90.39C255.437 90.39 255.04 90.52 254.76 90.78C254.513 91 254.39 91.2867 254.39 91.64C254.39 92.0067 254.5 92.3 254.72 92.52C254.987 92.7867 255.397 92.92 255.95 92.92C256.49 92.92 256.9 92.7867 257.18 92.52C257.4 92.3 257.51 92.0067 257.51 91.64C257.51 91.2933 257.387 91.0067 257.14 90.78C256.853 90.52 256.457 90.39 255.95 90.39ZM255.95 93.56C255.37 93.56 254.927 93.7033 254.62 93.99C254.327 94.2433 254.18 94.59 254.18 95.03C254.18 95.4633 254.327 95.8067 254.62 96.06C254.927 96.3333 255.37 96.47 255.95 96.47C256.523 96.47 256.97 96.33 257.29 96.05C257.577 95.7833 257.72 95.4433 257.72 95.03C257.72 94.6033 257.577 94.2567 257.29 93.99C256.977 93.7033 256.53 93.56 255.95 93.56Z"
      fill="#888F97"
    />
    <rect x="247" y="103" width="12" height="3" fill="#02C58D" />
    <path
      d="M247.57 112.72C248.263 112.72 248.817 112.893 249.23 113.24C249.643 113.593 249.85 114.067 249.85 114.66C249.85 115.467 249.46 116 248.68 116.26C249.107 116.393 249.427 116.597 249.64 116.87C249.88 117.15 250 117.5 250 117.92C250 118.567 249.773 119.097 249.32 119.51C248.86 119.93 248.26 120.14 247.52 120.14C246.853 120.14 246.3 119.967 245.86 119.62C245.353 119.2 245.07 118.59 245.01 117.79H245.84C245.86 118.35 246.047 118.777 246.4 119.07C246.707 119.317 247.08 119.44 247.52 119.44C248.027 119.44 248.437 119.293 248.75 119C249.037 118.713 249.18 118.363 249.18 117.95C249.18 117.523 249.04 117.19 248.76 116.95C248.487 116.717 248.1 116.6 247.6 116.6H247.02V115.96H247.57C248.043 115.96 248.407 115.853 248.66 115.64C248.913 115.42 249.04 115.11 249.04 114.71C249.04 114.317 248.917 114.007 248.67 113.78C248.417 113.547 248.053 113.43 247.58 113.43C247.093 113.43 246.72 113.557 246.46 113.81C246.187 114.063 246.023 114.433 245.97 114.92H245.16C245.22 114.233 245.473 113.693 245.92 113.3C246.333 112.913 246.883 112.72 247.57 112.72ZM251.866 115.65C252.186 115.65 252.563 115.797 252.996 116.09C253.436 116.377 253.746 116.52 253.926 116.52C254.146 116.52 254.409 116.287 254.716 115.82L255.216 116.18C254.783 116.833 254.353 117.16 253.926 117.16C253.619 117.16 253.249 117.013 252.816 116.72C252.383 116.433 252.066 116.29 251.866 116.29C251.633 116.29 251.369 116.52 251.076 116.98L250.576 116.63C250.989 115.977 251.419 115.65 251.866 115.65ZM256.346 112.86H260.496V113.59H257.016L256.776 115.98H256.816C257.016 115.74 257.273 115.56 257.586 115.44C257.853 115.327 258.156 115.27 258.496 115.27C259.176 115.27 259.726 115.483 260.146 115.91C260.573 116.357 260.786 116.96 260.786 117.72C260.786 118.44 260.529 119.03 260.016 119.49C259.529 119.923 258.936 120.14 258.236 120.14C257.603 120.14 257.066 119.97 256.626 119.63C256.133 119.25 255.859 118.733 255.806 118.08H256.616C256.656 118.533 256.836 118.88 257.156 119.12C257.443 119.333 257.806 119.44 258.246 119.44C258.746 119.44 259.159 119.28 259.486 118.96C259.813 118.633 259.976 118.223 259.976 117.73C259.976 117.17 259.823 116.73 259.516 116.41C259.229 116.097 258.823 115.94 258.296 115.94C257.956 115.94 257.653 116.013 257.386 116.16C257.099 116.3 256.886 116.513 256.746 116.8H255.966L256.346 112.86Z"
      fill="#A2A7AD"
    />
    <path
      d="M282.842 91.86H283.612V96.71H284.772V97.38H283.612V99H282.832V97.38H279.242V96.6L282.842 91.86ZM282.802 92.93L279.932 96.71H282.832V92.93H282.802Z"
      fill="#888F97"
    />
    <rect x="276" y="105" width="12" height="1" fill="#02C58D" />
    <path
      d="M274.55 112.86H278.7V113.59H275.22L274.98 115.98H275.02C275.22 115.74 275.477 115.56 275.79 115.44C276.057 115.327 276.36 115.27 276.7 115.27C277.38 115.27 277.93 115.483 278.35 115.91C278.777 116.357 278.99 116.96 278.99 117.72C278.99 118.44 278.733 119.03 278.22 119.49C277.733 119.923 277.14 120.14 276.44 120.14C275.807 120.14 275.27 119.97 274.83 119.63C274.337 119.25 274.063 118.733 274.01 118.08H274.82C274.86 118.533 275.04 118.88 275.36 119.12C275.647 119.333 276.01 119.44 276.45 119.44C276.95 119.44 277.363 119.28 277.69 118.96C278.017 118.633 278.18 118.223 278.18 117.73C278.18 117.17 278.027 116.73 277.72 116.41C277.433 116.097 277.027 115.94 276.5 115.94C276.16 115.94 275.857 116.013 275.59 116.16C275.303 116.3 275.09 116.513 274.95 116.8H274.17L274.55 112.86ZM280.866 115.65C281.186 115.65 281.563 115.797 281.996 116.09C282.436 116.377 282.746 116.52 282.926 116.52C283.146 116.52 283.409 116.287 283.716 115.82L284.216 116.18C283.783 116.833 283.353 117.16 282.926 117.16C282.619 117.16 282.249 117.013 281.816 116.72C281.383 116.433 281.066 116.29 280.866 116.29C280.633 116.29 280.369 116.52 280.076 116.98L279.576 116.63C279.989 115.977 280.419 115.65 280.866 115.65ZM284.956 112.86H289.646V113.53L287.016 120H286.146L288.806 113.61H284.956V112.86Z"
      fill="#A2A7AD"
    />
    <path
      d="M308.664 90.86V98H307.844V91.86C307.404 92.3133 306.844 92.64 306.164 92.84V92.02C306.477 91.9333 306.811 91.7867 307.164 91.58C307.491 91.38 307.777 91.14 308.024 90.86H308.664ZM312 90.86H316.15V91.59H312.67L312.43 93.98H312.47C312.67 93.74 312.927 93.56 313.24 93.44C313.507 93.3267 313.81 93.27 314.15 93.27C314.83 93.27 315.38 93.4833 315.8 93.91C316.227 94.3567 316.44 94.96 316.44 95.72C316.44 96.44 316.183 97.03 315.67 97.49C315.183 97.9233 314.59 98.14 313.89 98.14C313.257 98.14 312.72 97.97 312.28 97.63C311.787 97.25 311.513 96.7333 311.46 96.08H312.27C312.31 96.5333 312.49 96.88 312.81 97.12C313.097 97.3333 313.46 97.44 313.9 97.44C314.4 97.44 314.813 97.28 315.14 96.96C315.467 96.6333 315.63 96.2233 315.63 95.73C315.63 95.17 315.477 94.73 315.17 94.41C314.883 94.0967 314.477 93.94 313.95 93.94C313.61 93.94 313.307 94.0133 313.04 94.16C312.753 94.3 312.54 94.5133 312.4 94.8H311.62L312 90.86Z"
      fill="#888F97"
    />
    <rect x="305" y="104" width="12" height="2" fill="#02C58D" />
    <path
      d="M304.82 113.42L311.06 115.38V116.12L304.82 118.09V117.36L309.96 115.75L304.82 114.14V113.42ZM311.06 116.95V117.63L304.82 119.59V118.91L311.06 116.95ZM312.441 112.86H317.131V113.53L314.501 120H313.631L316.291 113.61H312.441V112.86Z"
      fill="#A2A7AD"
    />
    <path d="M0 127H55L49 133H0V127Z" fill="#FF295A" />
    <path d="M61 127H371L365 133H55L61 127Z" fill="#888F97" />
    <path d="M377 127H390V133H371L377 127Z" fill="#02C58D" />
    <path
      d="M0.66 140.832H11.328V141.684H6.12V143.496C7.608 144.24 9.12 145.104 10.656 146.088L10.14 146.856C8.564 145.808 7.224 144.992 6.12 144.408V151.224H5.244V141.684H0.66V140.832ZM12.984 140.7H16.596V144.444H15.444V146.352H16.848V147.168H15.444V149.352C15.924 149.208 16.38 149.064 16.812 148.92V149.772C15.604 150.188 14.188 150.572 12.564 150.924L12.312 150.096L12.912 149.976V145.632H13.68V149.808C14.112 149.696 14.432 149.616 14.64 149.568V144.444H12.984V140.7ZM15.768 143.64V141.504H13.824V143.64H15.768ZM18.444 143.196C18.236 143.9 18.024 144.484 17.808 144.948L17.088 144.492C17.584 143.412 17.948 142.208 18.18 140.88L18.936 141.036C18.864 141.42 18.772 141.86 18.66 142.356H19.884V140.232H20.7V142.356H22.632V143.196H20.688C20.664 144.124 20.608 144.904 20.52 145.536H23.076V146.364H20.808C21.12 148.116 21.992 149.484 23.424 150.468L22.944 151.224C21.544 150.176 20.636 148.784 20.22 147.048C20.124 147.408 19.988 147.824 19.812 148.296C19.26 149.52 18.364 150.484 17.124 151.188L16.68 150.492C17.872 149.788 18.708 148.852 19.188 147.684C19.348 147.228 19.472 146.788 19.56 146.364H17.208V145.536H19.692C19.788 144.816 19.848 144.036 19.872 143.196H18.444Z"
      fill="#888F97"
    />
    <path
      d="M31.3201 141.264C32.1521 141.264 32.8161 141.472 33.3121 141.888C33.8081 142.312 34.0561 142.88 34.0561 143.592C34.0561 144.56 33.5881 145.2 32.6521 145.512C33.1641 145.672 33.5481 145.916 33.8041 146.244C34.0921 146.58 34.2361 147 34.2361 147.504C34.2361 148.28 33.9641 148.916 33.4201 149.412C32.8681 149.916 32.1481 150.168 31.2601 150.168C30.4601 150.168 29.7961 149.96 29.2681 149.544C28.6601 149.04 28.3201 148.308 28.2481 147.348H29.2441C29.2681 148.02 29.4921 148.532 29.9161 148.884C30.2841 149.18 30.7321 149.328 31.2601 149.328C31.8681 149.328 32.3601 149.152 32.7361 148.8C33.0801 148.456 33.2521 148.036 33.2521 147.54C33.2521 147.028 33.0841 146.628 32.7481 146.34C32.4201 146.06 31.9561 145.92 31.3561 145.92H30.6601V145.152H31.3201C31.8881 145.152 32.3241 145.024 32.6281 144.768C32.9321 144.504 33.0841 144.132 33.0841 143.652C33.0841 143.18 32.9361 142.808 32.6401 142.536C32.3361 142.256 31.9001 142.116 31.3321 142.116C30.7481 142.116 30.3001 142.268 29.9881 142.572C29.6601 142.876 29.4641 143.32 29.4001 143.904H28.4281C28.5001 143.08 28.8041 142.432 29.3401 141.96C29.8361 141.496 30.4961 141.264 31.3201 141.264ZM38.3114 141.264C39.2154 141.264 39.9154 141.496 40.4114 141.96C40.8754 142.384 41.1074 142.908 41.1074 143.532C41.1074 143.988 40.9994 144.372 40.7834 144.684C40.5354 145.028 40.1954 145.276 39.7634 145.428V145.452C40.2114 145.564 40.5914 145.812 40.9034 146.196C41.2394 146.604 41.4074 147.084 41.4074 147.636C41.4074 148.396 41.1434 149.004 40.6154 149.46C40.0554 149.932 39.2874 150.168 38.3114 150.168C37.3194 150.168 36.5514 149.932 36.0074 149.46C35.4794 149.004 35.2154 148.396 35.2154 147.636C35.2154 147.084 35.3834 146.604 35.7194 146.196C36.0394 145.804 36.4194 145.556 36.8594 145.452V145.428C36.4114 145.276 36.0714 145.028 35.8394 144.684C35.6234 144.372 35.5154 143.988 35.5154 143.532C35.5154 142.9 35.7474 142.376 36.2114 141.96C36.7074 141.496 37.4074 141.264 38.3114 141.264ZM38.3114 142.068C37.6954 142.068 37.2194 142.224 36.8834 142.536C36.5874 142.8 36.4394 143.144 36.4394 143.568C36.4394 144.008 36.5714 144.36 36.8354 144.624C37.1554 144.944 37.6474 145.104 38.3114 145.104C38.9594 145.104 39.4514 144.944 39.7874 144.624C40.0514 144.36 40.1834 144.008 40.1834 143.568C40.1834 143.152 40.0354 142.808 39.7394 142.536C39.3954 142.224 38.9194 142.068 38.3114 142.068ZM38.3114 145.872C37.6154 145.872 37.0834 146.044 36.7154 146.388C36.3634 146.692 36.1874 147.108 36.1874 147.636C36.1874 148.156 36.3634 148.568 36.7154 148.872C37.0834 149.2 37.6154 149.364 38.3114 149.364C38.9994 149.364 39.5354 149.196 39.9194 148.86C40.2634 148.54 40.4354 148.132 40.4354 147.636C40.4354 147.124 40.2634 146.708 39.9194 146.388C39.5434 146.044 39.0074 145.872 38.3114 145.872ZM45.3867 141.264C46.2907 141.264 46.9907 141.496 47.4867 141.96C47.9507 142.384 48.1827 142.908 48.1827 143.532C48.1827 143.988 48.0747 144.372 47.8587 144.684C47.6107 145.028 47.2707 145.276 46.8387 145.428V145.452C47.2867 145.564 47.6667 145.812 47.9787 146.196C48.3147 146.604 48.4827 147.084 48.4827 147.636C48.4827 148.396 48.2187 149.004 47.6907 149.46C47.1307 149.932 46.3627 150.168 45.3867 150.168C44.3947 150.168 43.6267 149.932 43.0827 149.46C42.5547 149.004 42.2907 148.396 42.2907 147.636C42.2907 147.084 42.4587 146.604 42.7947 146.196C43.1147 145.804 43.4947 145.556 43.9347 145.452V145.428C43.4867 145.276 43.1467 145.028 42.9147 144.684C42.6987 144.372 42.5907 143.988 42.5907 143.532C42.5907 142.9 42.8227 142.376 43.2867 141.96C43.7827 141.496 44.4827 141.264 45.3867 141.264ZM45.3867 142.068C44.7707 142.068 44.2947 142.224 43.9587 142.536C43.6627 142.8 43.5147 143.144 43.5147 143.568C43.5147 144.008 43.6467 144.36 43.9107 144.624C44.2307 144.944 44.7227 145.104 45.3867 145.104C46.0347 145.104 46.5267 144.944 46.8627 144.624C47.1267 144.36 47.2587 144.008 47.2587 143.568C47.2587 143.152 47.1107 142.808 46.8147 142.536C46.4707 142.224 45.9947 142.068 45.3867 142.068ZM45.3867 145.872C44.6907 145.872 44.1587 146.044 43.7907 146.388C43.4387 146.692 43.2627 147.108 43.2627 147.636C43.2627 148.156 43.4387 148.568 43.7907 148.872C44.1587 149.2 44.6907 149.364 45.3867 149.364C46.0747 149.364 46.6107 149.196 46.9947 148.86C47.3387 148.54 47.5107 148.132 47.5107 147.636C47.5107 147.124 47.3387 146.708 46.9947 146.388C46.6187 146.044 46.0827 145.872 45.3867 145.872Z"
      fill="#FF295A"
    />
    <path
      d="M345.992 140.196H346.88V143.904H351.332V144.744H346.88V149.88H352.352V150.72H341.672V149.88H345.992V140.196ZM360.956 145.716V150.084C361.42 149.916 361.88 149.68 362.336 149.376L362.492 150.168C361.804 150.56 361.032 150.88 360.176 151.128L359.816 150.384C360.048 150.288 360.164 150.16 360.164 150V145.716H359.348V144.924H360.164V140.22H360.956V144.924H364.292V145.716H362.708C362.796 147.708 363.376 149.356 364.448 150.66L363.86 151.248C362.7 149.752 362.076 147.908 361.988 145.716H360.956ZM357.116 144.132L356.96 146.088H358.976C358.976 148.016 358.924 149.32 358.82 150C358.7 150.68 358.24 151.044 357.44 151.092C357.264 151.092 356.976 151.076 356.576 151.044L356.384 150.276C356.768 150.308 357.06 150.324 357.26 150.324C357.708 150.324 357.968 150.108 358.04 149.676C358.112 149.22 358.148 148.288 358.148 146.88H356.108L356.372 143.328H358.088V141.456H356.228V140.664H358.928V144.132H357.116ZM354.284 140.4C354.98 141.008 355.54 141.58 355.964 142.116L355.364 142.716C354.988 142.212 354.432 141.628 353.696 140.964L354.284 140.4ZM354.02 143.268C354.644 143.812 355.2 144.392 355.688 145.008L355.1 145.596C354.684 145.036 354.128 144.448 353.432 143.832L354.02 143.268ZM355.664 146.724C355.24 148.284 354.78 149.728 354.284 151.056L353.504 150.732C354.048 149.348 354.52 147.916 354.92 146.436L355.664 146.724ZM364.388 141.372C363.652 142.628 362.768 143.56 361.736 144.168L361.304 143.556C362.264 142.972 363.092 142.076 363.788 140.868L364.388 141.372Z"
      fill="#888F97"
    />
    <path
      d="M372.968 141.432V150H371.984V142.632C371.456 143.176 370.784 143.568 369.968 143.808V142.824C370.344 142.72 370.744 142.544 371.168 142.296C371.56 142.056 371.904 141.768 372.2 141.432H372.968ZM379.395 141.264C380.227 141.264 380.891 141.472 381.387 141.888C381.883 142.312 382.131 142.88 382.131 143.592C382.131 144.56 381.663 145.2 380.727 145.512C381.239 145.672 381.623 145.916 381.879 146.244C382.167 146.58 382.311 147 382.311 147.504C382.311 148.28 382.039 148.916 381.495 149.412C380.943 149.916 380.223 150.168 379.335 150.168C378.535 150.168 377.871 149.96 377.343 149.544C376.735 149.04 376.395 148.308 376.323 147.348H377.319C377.343 148.02 377.567 148.532 377.991 148.884C378.359 149.18 378.807 149.328 379.335 149.328C379.943 149.328 380.435 149.152 380.811 148.8C381.155 148.456 381.327 148.036 381.327 147.54C381.327 147.028 381.159 146.628 380.823 146.34C380.495 146.06 380.031 145.92 379.431 145.92H378.735V145.152H379.395C379.963 145.152 380.399 145.024 380.703 144.768C381.007 144.504 381.159 144.132 381.159 143.652C381.159 143.18 381.011 142.808 380.715 142.536C380.411 142.256 379.975 142.116 379.407 142.116C378.823 142.116 378.375 142.268 378.063 142.572C377.735 142.876 377.539 143.32 377.475 143.904H376.503C376.575 143.08 376.879 142.432 377.415 141.96C377.911 141.496 378.571 141.264 379.395 141.264ZM386.507 141.264C388.091 141.264 389.003 142.028 389.243 143.556H388.271C388.079 142.58 387.487 142.092 386.495 142.092C385.815 142.092 385.287 142.424 384.911 143.088C384.535 143.696 384.347 144.496 384.347 145.488C384.347 145.592 384.351 145.696 384.359 145.8H384.407C384.631 145.344 384.939 145 385.331 144.768C385.707 144.52 386.151 144.396 386.663 144.396C387.479 144.396 388.139 144.66 388.643 145.188C389.139 145.724 389.387 146.404 389.387 147.228C389.387 148.068 389.115 148.768 388.571 149.328C388.011 149.888 387.319 150.168 386.495 150.168C385.463 150.168 384.679 149.78 384.143 149.004C383.647 148.284 383.399 147.264 383.399 145.944C383.399 144.568 383.667 143.456 384.203 142.608C384.763 141.712 385.531 141.264 386.507 141.264ZM386.471 145.212C385.911 145.212 385.443 145.404 385.067 145.788C384.699 146.164 384.515 146.652 384.515 147.252C384.515 147.86 384.691 148.352 385.043 148.728C385.403 149.136 385.879 149.34 386.471 149.34C387.039 149.34 387.507 149.144 387.875 148.752C388.235 148.344 388.415 147.836 388.415 147.228C388.415 146.628 388.239 146.144 387.887 145.776C387.535 145.4 387.063 145.212 386.471 145.212Z"
      fill="#02C58D"
    />
  </svg>
);

// 市场-美股-期权001
export const MarketUsa001Icon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 20V25M20 18V25M24 14V25M8 22V25M12 18V25"
      stroke="#1B212D"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26 7L17.354 15.646C17.3076 15.6926 17.2524 15.7295 17.1916 15.7547C17.1309 15.7799 17.0658 15.7929 17 15.7929C16.9342 15.7929 16.8691 15.7799 16.8084 15.7547C16.7476 15.7295 16.6924 15.6926 16.646 15.646L13.354 12.354C13.2602 12.2603 13.1331 12.2076 13.0005 12.2076C12.8679 12.2076 12.7408 12.2603 12.647 12.354L6 19"
      stroke="#FF4000"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

// 市场-美股-盘前盘后榜002
export const MarketUsa002Icon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 9V13" stroke="#1B212D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13 19V21M21 7V9" stroke="#1B212D" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M21 17V20M7 7V23C7 23.5304 7.21071 24.0391 7.58579 24.4142C7.96086 24.7893 8.46957 25 9 25H25"
      stroke="#1B212D"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 13H12C11.4477 13 11 13.4477 11 14V18C11 18.5523 11.4477 19 12 19H14C14.5523 19 15 18.5523 15 18V14C15 13.4477 14.5523 13 14 13Z"
      stroke="#FF4000"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22 9H20C19.4477 9 19 9.44772 19 10V16C19 16.5523 19.4477 17 20 17H22C22.5523 17 23 16.5523 23 16V10C23 9.44772 22.5523 9 22 9Z"
      stroke="#FF4000"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

// 市场-美股-区间涨跌幅003
export const MarketUsa003Icon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 17.5323C7 17.1996 7.16555 16.8886 7.44162 16.7028L12.8384 13.0703C13.3035 12.7573 13.9349 12.8876 14.238 13.3591L15.7217 15.667C16.0182 16.1284 16.6311 16.2648 17.0953 15.9727L23.4675 11.9641C24.1335 11.5451 25 12.0238 25 12.8105V23C25 23.5523 24.5523 24 24 24H8C7.44772 24 7 23.5523 7 23V17.5323Z"
      stroke="#1B212D"
      stroke-width="1.25"
    />
    <path
      d="M7 14L13.7129 9.52474C14.1545 9.23034 14.7492 9.3322 15.0676 9.75679L16.9401 12.2535C17.2554 12.6739 17.8422 12.7785 18.2834 12.4931L24.5785 8.41978C24.9968 8.14911 24.8051 7.5 24.3069 7.5H22"
      stroke="#FF4000"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
);

// 市场-美股-新股认购004
export const MarketUsa004Icon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="7" width="20" height="14" rx="2" stroke="#1B212D" stroke-width="1.25" />
    <path d="M11 24H21" stroke="#1B212D" stroke-width="1.25" stroke-linecap="round" />
    <path d="M11.5 18V13" stroke="#FF4000" stroke-width="1.25" stroke-linecap="round" />
    <path d="M15.5 18V11" stroke="#FF4000" stroke-width="1.25" stroke-linecap="round" />
    <path d="M19.5 18V15" stroke="#FF4000" stroke-width="1.25" stroke-linecap="round" />
  </svg>
);

// 我的-账户与安全
export const MyAccountIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H18C18.7956 4 19.5587 4.31607 20.1213 4.87868C20.6839 5.44129 21 6.20435 21 7V17C21 17.7956 20.6839 18.5587 20.1213 19.1213C19.5587 19.6839 18.7956 20 18 20H6C5.20435 20 4.44129 19.6839 3.87868 19.1213C3.31607 18.5587 3 17.7956 3 17V7Z"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 8H17M15 12H17M7 16H17"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 10C7 10.5304 7.21071 11.0391 7.58579 11.4142C7.96086 11.7893 8.46957 12 9 12C9.53043 12 10.0391 11.7893 10.4142 11.4142C10.7893 11.0391 11 10.5304 11 10C11 9.46957 10.7893 8.96086 10.4142 8.58579C10.0391 8.21071 9.53043 8 9 8C8.46957 8 7.96086 8.21071 7.58579 8.58579C7.21071 8.96086 7 9.46957 7 10Z"
      stroke="#FF4000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

// 我的-行情
export const MyMarketConditionsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.46875 3.52783H21.5313M3.52778 3.52783V14.1181C3.52778 14.6799 3.75093 15.2186 4.14814 15.6158C4.54535 16.013 5.08409 16.2362 5.64583 16.2362H18.3542C18.9159 16.2362 19.4546 16.013 19.8519 15.6158C20.2491 15.2186 20.4722 14.6799 20.4722 14.1181V3.52783M12 16.2362V20.4723M8.82292 20.4723H15.1771"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.76367 12L10.9408 8.82294L13.0588 10.941L16.2359 7.76392"
      stroke="#FF4000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//我的-奖励中心
export const MyRewardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 7.99995C6.83696 7.99995 6.20107 7.73656 5.73223 7.26772C5.26339 6.79887 5 6.16299 5 5.49995C5 4.83691 5.26339 4.20102 5.73223 3.73218C6.20107 3.26334 6.83696 2.99995 7.5 2.99995C8.46469 2.98314 9.41003 3.45121 10.2127 4.34311C11.0154 5.23501 11.6383 6.50935 12 7.99995C12.3617 6.50935 12.9846 5.23501 13.7873 4.34311C14.59 3.45121 15.5353 2.98314 16.5 2.99995C17.163 2.99995 17.7989 3.26334 18.2678 3.73218C18.7366 4.20102 19 4.83691 19 5.49995C19 6.16299 18.7366 6.79887 18.2678 7.26772C17.7989 7.73656 17.163 7.99995 16.5 7.99995"
      stroke="#FF4000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 8V21M3 9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V11C21 11.2652 20.8946 11.5196 20.7071 11.7071C20.5196 11.8946 20.2652 12 20 12H4C3.73478 12 3.48043 11.8946 3.29289 11.7071C3.10536 11.5196 3 11.2652 3 11V9Z"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 12V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V12"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//我的-风险测评
export const MyRiskIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.4602 20.846C8.44953 19.9127 5.9269 17.8324 4.43746 15.0545C2.94801 12.2765 2.61136 9.02411 3.50024 6C6.61577 6.14257 9.66441 5.06658 12.0002 3C14.3361 5.06658 17.3847 6.14257 20.5002 6C20.9572 7.55473 21.0923 9.17778 20.9067 10.7716"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.42 14.41C18.615 14.215 18.8465 14.0603 19.1013 13.9548C19.3561 13.8492 19.6292 13.7949 19.905 13.7949C20.1808 13.7949 20.4539 13.8492 20.7087 13.9548C20.9635 14.0603 21.195 14.215 21.39 14.41C21.585 14.605 21.7397 14.8366 21.8452 15.0914C21.9508 15.3461 22.0051 15.6192 22.0051 15.895C22.0051 16.1708 21.9508 16.4439 21.8452 16.6987C21.7397 16.9535 21.585 17.185 21.39 17.38L18 20.8H15V17.8L18.42 14.41Z"
      stroke="#FF4000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//我的-W8BEN确认
export const MyW8BenIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.99986 5H6.30615C5.77572 5 5.26701 5.21071 4.89194 5.58579C4.51687 5.96086 4.30615 6.46957 4.30615 7V19C4.30615 19.5304 4.51687 20.0391 4.89194 20.4142C5.26701 20.7893 5.77572 21 6.30615 21H11.4999M19.6936 14V7C19.6936 6.46957 19.4829 5.96086 19.1078 5.58579C18.7328 5.21071 18.224 5 17.6936 5H14.9999"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H13C13.5304 3 14.0391 3.21071 14.4142 3.58579C14.7893 3.96086 15 4.46957 15 5C15 5.53043 14.7893 6.03914 14.4142 6.41421C14.0391 6.78929 13.5304 7 13 7H11C10.4696 7 9.96086 6.78929 9.58579 6.41421C9.21071 6.03914 9 5.53043 9 5Z"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M15 20L17 22L21 18" stroke="#1B212D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M7.69141 10.9219L8.81547 14.8057C8.81818 14.8151 8.83133 14.8154 8.83452 14.8062L10.0725 11.2307C10.0756 11.2217 10.0883 11.2217 10.0914 11.2307L11.3298 14.8688C11.3329 14.878 11.346 14.8778 11.3488 14.8684L12.5273 10.9219"
      stroke="#FF4000"
      stroke-linecap="round"
    />
    <ellipse cx="14.9023" cy="11.966" rx="1.23438" ry="0.944041" stroke="#FF4000" />
    <ellipse cx="14.9023" cy="14.0371" rx="1.40625" ry="1.04102" stroke="#FF4000" />
  </svg>
);

//我的-设置
export const MySettingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.2319 3.89017C10.6816 2.03661 13.3184 2.03661 13.7681 3.89017C13.8355 4.16862 13.9678 4.42721 14.1541 4.64489C14.3404 4.86257 14.5754 5.03318 14.8401 5.14284C15.1048 5.25251 15.3917 5.29812 15.6773 5.27597C15.963 5.25383 16.2394 5.16454 16.484 5.01539C18.1127 4.02317 19.9779 5.88728 18.9857 7.51706C18.8367 7.76158 18.7476 8.0378 18.7255 8.32326C18.7034 8.60872 18.749 8.89537 18.8585 9.1599C18.968 9.42443 19.1384 9.65939 19.3559 9.84567C19.5733 10.0319 19.8316 10.1643 20.1098 10.2319C21.9634 10.6816 21.9634 13.3184 20.1098 13.7681C19.8314 13.8355 19.5728 13.9678 19.3551 14.1541C19.1374 14.3404 18.9668 14.5754 18.8572 14.8401C18.7475 15.1048 18.7019 15.3917 18.724 15.6773C18.7462 15.963 18.8355 16.2394 18.9846 16.484C19.9768 18.1127 18.1127 19.9779 16.4829 18.9857C16.2384 18.8367 15.9622 18.7476 15.6767 18.7255C15.3913 18.7034 15.1046 18.749 14.8401 18.8585C14.5756 18.968 14.3406 19.1384 14.1543 19.3559C13.9681 19.5733 13.8357 19.8316 13.7681 20.1098C13.3184 21.9634 10.6816 21.9634 10.2319 20.1098C10.1645 19.8314 10.0322 19.5728 9.84592 19.3551C9.65962 19.1374 9.42456 18.9668 9.15987 18.8572C8.89517 18.7475 8.60833 18.7019 8.32267 18.724C8.03702 18.7462 7.76063 18.8355 7.516 18.9846C5.88728 19.9768 4.02211 18.1127 5.01433 16.4829C5.16327 16.2384 5.25241 15.9622 5.27451 15.6767C5.29661 15.3913 5.25103 15.1046 5.1415 14.8401C5.03196 14.5756 4.86155 14.3406 4.64412 14.1543C4.42669 13.9681 4.16837 13.8357 3.89017 13.7681C2.03661 13.3184 2.03661 10.6816 3.89017 10.2319C4.16862 10.1645 4.42721 10.0322 4.64489 9.84592C4.86257 9.65962 5.03318 9.42456 5.14284 9.15987C5.25251 8.89517 5.29812 8.60833 5.27597 8.32267C5.25383 8.03702 5.16454 7.76063 5.01539 7.516C4.02317 5.88728 5.88728 4.02211 7.51706 5.01433C8.57261 5.65611 9.94061 5.08822 10.2319 3.89017Z"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.8335 11.9999C8.8335 12.8398 9.16713 13.6452 9.76099 14.2391C10.3549 14.833 11.1603 15.1666 12.0002 15.1666C12.84 15.1666 13.6455 14.833 14.2393 14.2391C14.8332 13.6452 15.1668 12.8398 15.1668 11.9999C15.1668 11.1601 14.8332 10.3546 14.2393 9.76075C13.6455 9.16688 12.84 8.83325 12.0002 8.83325C11.1603 8.83325 10.3549 9.16688 9.76099 9.76075C9.16713 10.3546 8.8335 11.1601 8.8335 11.9999Z"
      stroke="#FF4000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//我的-功能建议
export const MyFunctionIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5 19H6C5.20435 19 4.44129 18.6839 3.87868 18.1213C3.31607 17.5587 3 16.7956 3 16V8C3 7.20435 3.31607 6.44129 3.87868 5.87868C4.44129 5.31607 5.20435 5 6 5H18C18.7956 5 19.5587 5.31607 20.1213 5.87868C20.6839 6.44129 21 7.20435 21 8V11M7 15H12M17 12H14M11 12H10"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.42 15.61C18.615 15.415 18.8465 15.2603 19.1013 15.1547C19.3561 15.0492 19.6292 14.9949 19.905 14.9949C20.1808 14.9949 20.4539 15.0492 20.7087 15.1547C20.9635 15.2603 21.195 15.415 21.39 15.61C21.585 15.805 21.7397 16.0365 21.8452 16.2913C21.9508 16.5461 22.0051 16.8192 22.0051 17.095C22.0051 17.3708 21.9508 17.6439 21.8452 17.8987C21.7397 18.1535 21.585 18.385 21.39 18.58L18 22H15V19L18.42 15.61Z"
      stroke="#FF4000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//我的-关于我们
export const MyAboutUsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 9H12.01M11 12H12V16H13"
      stroke="#FF4000"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 3C19.2 3 21 4.8 21 12C21 19.2 19.2 21 12 21C4.8 21 3 19.2 3 12C3 4.8 4.8 3 12 3Z"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//箭头图标
export const ArrowIcon = (props) => {
  let color1 = '#C2C3CB';
  let color2 = '#C2C3CB';

  const getColors = () => {
    if (props.sort === 'ASC') {
      color1 = '#A2A7AD';
      color2 = '#C2C3CB';
    } else if (props.sort === 'DESC') {
      color1 = '#C2C3CB';
      color2 = '#A2A7AD';
    } else {
      color1 = '#C2C3CB';
      color2 = '#C2C3CB';
    }
    return {
      color1,
      color2,
    };
  };
  return (
    <svg width="7" height="11" viewBox="0 0 7 11" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.61639 0.615668C2.81457 0.321442 3.2476 0.321441 3.44579 0.615667L5.53724 3.72067C5.76094 4.05278 5.52297 4.5 5.12254 4.5H0.939636C0.539207 4.5 0.301234 4.05278 0.524938 3.72067L2.61639 0.615668Z"
        fill={getColors().color1}
      />
      <path
        d="M2.61639 10.3843C2.81457 10.6786 3.2476 10.6786 3.44579 10.3843L5.53724 7.27933C5.76094 6.94722 5.52297 6.5 5.12254 6.5H0.939636C0.539207 6.5 0.301234 6.94722 0.524938 7.27933L2.61639 10.3843Z"
        fill={getColors().color2}
      />
    </svg>
  );
};

//默认头像
export const DefaultUserIcon = () => (
  <svg width="72" height="72" viewBox="0 0 72 72" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_23_1194)">
      <path
        d="M-0.112305 35.9298C-0.112305 40.6648 0.820318 45.3534 2.63231 49.7279C4.44431 54.1025 7.10019 58.0773 10.4483 61.4254C13.7965 64.7735 17.7713 67.4294 22.1458 69.2414C26.5204 71.0534 31.209 71.986 35.9439 71.986C40.6789 71.986 45.3675 71.0534 49.7421 69.2414C54.1166 67.4294 58.0914 64.7735 61.4396 61.4254C64.7877 58.0773 67.4436 54.1025 69.2556 49.7279C71.0676 45.3534 72.0002 40.6648 72.0002 35.9298C72.0002 31.1948 71.0676 26.5062 69.2556 22.1317C67.4436 17.7571 64.7877 13.7823 61.4396 10.4342C58.0914 7.08603 54.1166 4.43015 49.7421 2.61815C45.3675 0.806158 40.6789 -0.126465 35.9439 -0.126465C31.209 -0.126465 26.5204 0.806158 22.1458 2.61815C17.7713 4.43015 13.7965 7.08603 10.4483 10.4342C7.10019 13.7823 4.44431 17.7571 2.63231 22.1317C0.820318 26.5062 -0.112305 31.1948 -0.112305 35.9298Z"
        fill="#FFD1C3"
      />
      <path
        d="M25.7253 27.1323C25.7253 32.4621 30.116 36.7805 35.526 36.7805C40.936 36.7805 45.3267 32.4621 45.3267 27.1323C45.3267 21.8025 40.936 17.4841 35.526 17.4841C30.116 17.4841 25.7253 21.8025 25.7253 27.1323ZM40.021 38.5062H31.8578C24.9467 38.5062 19.328 44.0527 19.2236 50.9638V51.7745C19.2236 54.5758 24.8825 54.5758 31.8578 54.5758H40.021C47.0203 54.5758 52.6551 54.5758 52.6551 51.7745V50.9638C52.5588 44.0527 46.932 38.5062 40.021 38.5062Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_23_1194">
        <rect width="72" height="72" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// Logo
export const LogoIcon = () => (
  <svg width="72" height="72" viewBox="0 0 72 72" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="36" cy="36" r="36" fill="#FFD1C3" />
  </svg>
);

//消息-系统公告
export const MessageSystemIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
      fill="#FFF3EF"
    />
    <path
      d="M21 29V30C21 30.7956 21.3161 31.5587 21.8787 32.1213C22.4413 32.6839 23.2044 33 24 33C24.7956 33 25.5587 32.6839 26.1213 32.1213C26.6839 31.5587 27 30.7956 27 30V29M22 17C22 16.4696 22.2107 15.9609 22.5858 15.5858C22.9609 15.2107 23.4696 15 24 15C24.5304 15 25.0391 15.2107 25.4142 15.5858C25.7893 15.9609 26 16.4696 26 17C27.1484 17.543 28.1274 18.3883 28.8321 19.4453C29.5367 20.5023 29.9404 21.7311 30 23V26C30.0753 26.6217 30.2954 27.2171 30.6428 27.7381C30.9902 28.2592 31.4551 28.6914 32 29H16C16.5449 28.6914 17.0098 28.2592 17.3572 27.7381C17.7046 27.2171 17.9247 26.6217 18 26V23C18.0596 21.7311 18.4633 20.5023 19.1679 19.4453C19.8726 18.3883 20.8516 17.543 22 17Z"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//消息-业务消息
export const MessageBusinessIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
      fill="#FFF3EF"
    />
    <path
      d="M21 17H19C18.4696 17 17.9609 17.2107 17.5858 17.5858C17.2107 17.9609 17 18.4696 17 19V31C17 31.5304 17.2107 32.0391 17.5858 32.4142C17.9609 32.7893 18.4696 33 19 33H29C29.5304 33 30.0391 32.7893 30.4142 32.4142C30.7893 32.0391 31 31.5304 31 31V19C31 18.4696 30.7893 17.9609 30.4142 17.5858C30.0391 17.2107 29.5304 17 29 17H27"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 26L23 28L27 24M21 17C21 16.4696 21.2107 15.9609 21.5858 15.5858C21.9609 15.2107 22.4696 15 23 15H25C25.5304 15 26.0391 15.2107 26.4142 15.5858C26.7893 15.9609 27 16.4696 27 17C27 17.5304 26.7893 18.0391 26.4142 18.4142C26.0391 18.7893 25.5304 19 25 19H23C22.4696 19 21.9609 18.7893 21.5858 18.4142C21.2107 18.0391 21 17.5304 21 17Z"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//消息-订阅消息
export const MessageSubscriptionIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
      fill="#FFF3EF"
    />
    <path
      d="M28 15V19M20 15V19M16 23H32M19 26H19.013M22.01 26H22.015M25.01 26H25.015M28.015 26H28.02M25.015 29H25.02M19.01 29H19.015M22.01 29H22.015M16 19C16 18.4696 16.2107 17.9609 16.5858 17.5858C16.9609 17.2107 17.4696 17 18 17H30C30.5304 17 31.0391 17.2107 31.4142 17.5858C31.7893 17.9609 32 18.4696 32 19V31C32 31.5304 31.7893 32.0391 31.4142 32.4142C31.0391 32.7893 30.5304 33 30 33H18C17.4696 33 16.9609 32.7893 16.5858 32.4142C16.2107 32.0391 16 31.5304 16 31V19Z"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//消息-资讯推送
export const MessageInformationIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
      fill="#FFF3EF"
    />
    <path
      d="M26 15V19C26 19.2652 26.1054 19.5196 26.2929 19.7071C26.4804 19.8946 26.7348 20 27 20H31"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29 33H19C18.4696 33 17.9609 32.7893 17.5858 32.4142C17.2107 32.0391 17 31.5304 17 31V17C17 16.4696 17.2107 15.9609 17.5858 15.5858C17.9609 15.2107 18.4696 15 19 15H26L31 20V31C31 31.5304 30.7893 32.0391 30.4142 32.4142C30.0391 32.7893 29.5304 33 29 33Z"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24 29C24 28.2044 23.6839 27.4413 23.1213 26.8787C22.5587 26.3161 21.7956 26 21 26M27 29C27 27.4087 26.3679 25.8826 25.2426 24.7574C24.1174 23.6321 22.5913 23 21 23M21 29H21.01"
      stroke="#1B212D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//实心下箭头
export const SolidArrowLeftIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.75 12.0001H3.25M3.25 12.0001L10.0972 5.15283M3.25 12.0001L10.0972 18.8473"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//实心下箭头
export const SolidArrowDownIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.87889 8.48875C5.47557 9.16002 6.52443 9.16002 7.12111 8.48875L9.78085 5.49655C10.6407 4.5292 9.95401 3 8.65973 3H3.34027C2.04599 3 1.35928 4.52919 2.21915 5.49655L4.87889 8.48875Z"
      fill="currentColor"
    />
  </svg>
);

//实心向上箭头
export const SolidArrowUpIcon = () => (
  <svg width="10" height="6" viewBox="0 0 10 6" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.88066 0.292922C4.27119 -0.097602 4.90435 -0.0976021 5.29488 0.292922L8.88066 3.87871C9.51063 4.50867 9.06446 5.58582 8.17356 5.58582H1.00198C0.111077 5.58582 -0.33509 4.50867 0.294875 3.87871L3.88066 0.292922Z"
      fill="currentColor"
    />
  </svg>
);

//线条向下箭头
export const LineArrowDownIcon = () => (
  <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.42 0.5L5.16 3.76C4.775 4.145 4.145 4.145 3.76 3.76L0.5 0.5"
      stroke="#A2A7AD"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//线条向上箭头
export const LineArrowUpIcon = () => (
  <svg width="384" height="12" viewBox="0 0 384 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M195.71 8.02344L192.45 4.76344C192.065 4.37844 191.435 4.37844 191.05 4.76344L187.79 8.02344"
      stroke="#A2A7AD"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

//实心爱心
export const SolidHeartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.750003 9.5529C0.749973 8.24915 1.13886 6.97501 1.86692 5.89348C2.59498 4.81195 3.62912 3.97219 4.83706 3.4816C6.04499 2.99102 7.37182 2.87192 8.64781 3.13954C9.58677 3.33647 10.4668 3.73621 11.2284 4.30604C11.6793 4.64341 12.3207 4.64341 12.7716 4.30604C13.5332 3.73621 14.4132 3.33647 15.3522 3.13954C16.6282 2.87192 17.955 2.99102 19.163 3.4816C20.3709 3.97219 21.405 4.81195 22.1331 5.89348C22.8611 6.97501 23.25 8.24915 23.25 9.5529C23.2525 10.5764 23.014 11.586 22.5538 12.5002C22.0936 13.4144 21.4246 14.2073 20.601 14.8149L13.1858 20.9252C12.7734 21.265 12.2536 21.4471 11.7193 21.4387C11.1851 21.4303 10.6712 21.232 10.2698 20.8794L3.04725 14.5352C2.32628 13.9207 1.74744 13.1569 1.35079 12.2966C0.954135 11.4364 0.749144 10.5002 0.750003 9.5529Z"
      fill="#FF4E4E"
    />
  </svg>
);

//空心爱心
export const BoderHeartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.11914 4.17676C6.18882 3.74232 7.36419 3.63704 8.49414 3.87402C9.32548 4.04844 10.105 4.40171 10.7793 4.90625C11.4966 5.44292 12.5034 5.44292 13.2207 4.90625C13.895 4.40171 14.6745 4.04844 15.5059 3.87402C16.6358 3.63704 17.8112 3.74232 18.8809 4.17676C19.9505 4.6112 20.8661 5.35482 21.5107 6.3125C22.1554 7.27019 22.5 8.39827 22.5 9.55273V9.55469C22.5022 10.4604 22.2911 11.3541 21.8838 12.1631C21.4766 12.9718 20.8848 13.6733 20.1562 14.2109L20.1396 14.2236L20.124 14.2363L12.709 20.3467C12.4342 20.5732 12.0875 20.694 11.7314 20.6885C11.3754 20.6829 11.0323 20.5514 10.7646 20.3164L3.54199 13.9717L3.53418 13.9639L3.30078 13.7539C2.77028 13.2496 2.3395 12.6488 2.03223 11.9824C1.68109 11.2209 1.49926 10.3923 1.5 9.55371V9.55273C1.5 8.39827 1.84458 7.27019 2.48926 6.3125C3.13395 5.35482 4.04955 4.6112 5.11914 4.17676Z"
      stroke="#A2A7AD"
      stroke-width="1.5"
    />
  </svg>
);

//排序图标,上下箭头
export const SortDefaultIcon = () => {
  return (
    <svg width="7" height="11" viewBox="0 0 7 11" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.61639 0.615668C2.81457 0.321442 3.2476 0.321441 3.44579 0.615667L5.53724 3.72067C5.76094 4.05278 5.52297 4.5 5.12254 4.5H0.939636C0.539207 4.5 0.301234 4.05278 0.524938 3.72067L2.61639 0.615668Z"
        fill="currentColor"
      />
      <path
        d="M2.61639 10.3843C2.81457 10.6786 3.2476 10.6786 3.44579 10.3843L5.53724 7.27933C5.76094 6.94722 5.52297 6.5 5.12254 6.5H0.939636C0.539207 6.5 0.301234 6.94722 0.524938 7.27933L2.61639 10.3843Z"
        fill="currentColor"
      />
    </svg>
  );
};

//排序图标,上下箭头（Solid：mergeProps + 在 JSX 内读 props.order，保证 order 变化时 path fill 更新）
export const SortIcon = (rawProps: { order?: 'asc' | 'desc' }) => {
  const props = mergeProps({ order: 'desc' as const }, rawProps);
  const active = 'var(--color-primary)';
  const muted = 'currentColor';

  return (
    <svg width="7" height="11" viewBox="0 0 7 11" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.61639 0.615668C2.81457 0.321442 3.2476 0.321441 3.44579 0.615667L5.53724 3.72067C5.76094 4.05278 5.52297 4.5 5.12254 4.5H0.939636C0.539207 4.5 0.301234 4.05278 0.524938 3.72067L2.61639 0.615668Z"
        fill={props.order === 'asc' ? active : muted}
      />
      <path
        d="M2.61639 10.3843C2.81457 10.6786 3.2476 10.6786 3.44579 10.3843L5.53724 7.27933C5.76094 6.94722 5.52297 6.5 5.12254 6.5H0.939636C0.539207 6.5 0.301234 6.94722 0.524938 7.27933L2.61639 10.3843Z"
        fill={props.order === 'desc' ? active : muted}
      />
    </svg>
  );
};

//实心点
export const SolidPointIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="10" height="10" rx="5" fill="#F5F5F5" />
      <circle cx="7" cy="7" r="2" fill="#888F97" />
    </svg>
  );
};

//错误图片
export const ErrorImageIcon = () => {
  return (
    <svg width="100" height="60" viewBox="0 0 100 60" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H92C96.4183 0 100 3.58172 100 8V52C100 56.4183 96.4183 60 92 60H8C3.58172 60 0 56.4183 0 52V8Z"
        fill="#F5F5F5"
      />
      <g opacity="0.2">
        <path
          opacity="0.4"
          d="M50.5476 25.2278C52.3046 23.4844 55.3005 24.7242 55.3005 27.1945L55.3005 42.2197C55.3005 43.7528 54.0529 44.9956 52.514 44.9956L37.3709 44.9956C34.8857 44.9956 33.6437 42.0001 35.4045 40.253L50.5476 25.2278Z"
          fill="black"
        />
        <path
          opacity="0.4"
          d="M61.5412 28.8623C62.9756 27.4391 65.4213 28.4512 65.4213 30.468L65.4213 42.7342C65.4213 43.9858 64.4029 45.0004 63.1465 45.0004L50.784 45.0004C48.7552 45.0004 47.7412 42.5549 49.1787 41.1286L61.5412 28.8623Z"
          fill="black"
        />
        <path
          opacity="0.4"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M60.2329 21.4962C62.0278 21.4962 63.4827 20.0419 63.4827 18.2481C63.4827 16.4542 62.0278 15 60.2329 15C58.4381 15 56.9832 16.4542 56.9832 18.2481C56.9832 20.0419 58.4381 21.4962 60.2329 21.4962Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

//空数据图标
export const NoDataIcon = () => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="18" width="38" height="33" rx="4" fill="#E3E3E3" />
      <path
        d="M17 4H40L52 16V47A4 4 0 0 1 48 51H18A4 4 0 0 1 14 47V7A3 3 0 0 1 17 4Z"
        fill="#C5C5C5"
      />
      <path d="M40 4L52 16H40Z" fill="#ECECEC" />
      <rect x="19" y="27" width="27" height="3" rx="1.5" fill="#ECECEC" />
      <rect x="19" y="33.5" width="27" height="3" rx="1.5" fill="#ECECEC" />
      <rect x="19" y="40" width="13" height="3" rx="1.5" fill="#ECECEC" />
    </svg>
  );
};

export const EyeIcon = (props: { visible: boolean }) => (
  <div style={{ width: '20px', height: '20px', 'flex-shrink': '0', cursor: 'pointer' }}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: props.visible ? 'none' : 'block' }}
    >
      <path
        d="M4.03451 7.9223C4.00616 7.83344 3.9951 7.7395 4.00198 7.64607C4.00887 7.55263 4.03355 7.46159 4.07457 7.37836C4.11559 7.29512 4.17212 7.22138 4.24079 7.16151C4.30947 7.10163 4.3889 7.05684 4.47437 7.02979C4.55984 7.00274 4.64962 6.99399 4.73838 7.00404C4.82714 7.01409 4.91307 7.04275 4.99108 7.08832C5.06909 7.13388 5.13759 7.19543 5.19252 7.2693C5.24744 7.34318 5.28768 7.42788 5.31085 7.51839C6.70189 12.4088 13.301 12.4095 14.6933 7.52119C14.7183 7.43303 14.7596 7.35089 14.8148 7.27947C14.87 7.20804 14.938 7.14873 15.015 7.10492C15.0921 7.06111 15.1766 7.03365 15.2637 7.02412C15.3508 7.01459 15.4389 7.02317 15.5229 7.04937C15.6069 7.07557 15.6851 7.11887 15.7532 7.17682C15.8212 7.23476 15.8777 7.3062 15.9194 7.38707C15.9612 7.46793 15.9873 7.55663 15.9964 7.64811C16.0055 7.73958 15.9973 7.83204 15.9724 7.9202C15.7299 8.79614 15.3184 9.61034 14.7634 10.3122L15.6136 11.2054C15.7351 11.3375 15.8023 11.5143 15.8008 11.6978C15.7992 11.8814 15.7291 12.057 15.6055 12.1867C15.4818 12.3165 15.3146 12.3902 15.1397 12.3918C14.9649 12.3934 14.7964 12.3228 14.6707 12.1953L13.7964 11.2775C13.3247 11.6511 12.8035 11.9504 12.2494 12.1659L12.4874 13.1004C12.5128 13.1901 12.5209 13.2841 12.511 13.3771C12.5012 13.47 12.4738 13.56 12.4303 13.6416C12.3868 13.7232 12.3282 13.7949 12.2579 13.8523C12.1876 13.9098 12.1071 13.9519 12.021 13.9761C11.935 14.0003 11.8452 14.0062 11.7569 13.9934C11.6687 13.9806 11.5838 13.9494 11.5072 13.9015C11.4307 13.8537 11.364 13.7903 11.3112 13.715C11.2584 13.6396 11.2205 13.554 11.1998 13.463L10.957 12.5131C10.3255 12.6111 9.68001 12.6111 9.04851 12.5131L8.80578 13.463C8.78503 13.554 8.74713 13.6396 8.69432 13.715C8.64151 13.7903 8.57486 13.8537 8.4983 13.9015C8.42175 13.9494 8.33684 13.9806 8.24859 13.9934C8.16034 14.0062 8.07055 14.0003 7.9845 13.9761C7.89846 13.9519 7.81791 13.9098 7.74762 13.8523C7.67732 13.7949 7.61871 13.7232 7.57523 13.6416C7.53176 13.56 7.5043 13.47 7.49449 13.3771C7.48468 13.2841 7.49271 13.1901 7.5181 13.1004L7.75617 12.1659C7.20198 11.9502 6.68079 11.6507 6.20909 11.2768L5.33552 12.1953C5.21048 12.3267 5.04082 12.4006 4.86387 12.4008C4.68691 12.4009 4.51715 12.3272 4.39194 12.196C4.26672 12.0647 4.19631 11.8866 4.19618 11.7009C4.19606 11.5151 4.26623 11.3369 4.39127 11.2054L5.2415 10.3129C4.71869 9.65767 4.30125 8.86104 4.03317 7.923L4.03451 7.9223Z"
        fill="#1B212D"
      />
    </svg>

    {/* 睁眼（password 显示，#888F97） */}
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: props.visible ? 'block' : 'none' }}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.0986 6.98571C6.3103 5.96071 8.0386 5 10 5C11.9614 5 13.689 5.96071 14.9014 6.98571C15.4496 7.44395 15.9422 7.96742 16.3686 8.545C16.5457 8.79071 16.6941 9.03214 16.8012 9.25714C16.8992 9.46143 17 9.72714 17 10C17 10.2729 16.8985 10.5386 16.8012 10.7429C16.678 10.9929 16.5332 11.2312 16.3686 11.455C15.9422 12.0326 15.4496 12.5561 14.9014 13.0143C13.6897 14.0393 11.9614 15 10 15C8.0386 15 6.311 14.0393 5.0986 13.0143C4.55038 12.5561 4.05781 12.0326 3.6314 11.455C3.46677 11.2312 3.322 10.9929 3.1988 10.7429C3.1008 10.5386 3 10.2729 3 10C3 9.72714 3.1015 9.46143 3.1988 9.25714C3.3059 9.03214 3.4543 8.79071 3.6314 8.545C4.05781 7.96742 4.55038 7.44395 5.0986 6.98571ZM10 12.1429C10.557 12.1429 11.0911 11.9171 11.4849 11.5152C11.8788 11.1134 12.1 10.5683 12.1 10C12.1 9.43168 11.8788 8.88663 11.4849 8.48477C11.0911 8.08291 10.557 7.85714 10 7.85714C9.44305 7.85714 8.9089 8.08291 8.51508 8.48477C8.12125 8.88663 7.9 9.43168 7.9 10C7.9 10.5683 8.12125 11.1134 8.51508 11.5152C8.9089 11.9171 9.44305 12.1429 10 12.1429Z"
        fill="#1B212D"
      />
    </svg>
  </div>
);

export const FilterIcon = (color: any = '#A2A7AD') => (
  <svg width="15" height="16" viewBox="0 0 15 16" stroke={color} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.75 0.75H14.0833V2.56C14.0832 3.00199 13.9076 3.42585 13.595 3.73833L9.91667 7.41667V13.25L4.91667 
  14.9167V7.83333L1.18333 3.72667C0.904539 3.41994 0.750044 3.02033 0.75 2.60583V0.75Z"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
